/* ============================================================
   CARMESÍ · TrueFem Latte — theme.js
   Vanilla JS. No dependencies. Mobile-first interactions.
   ============================================================ */
/* 14-oct FIX «no me deja quitar Bovine»: las escrituras al carrito (add/change/update/clear)
   iban EN PARALELO (regalos del cajón + plan del popup + el «Quitar» de la clienta) y Shopify
   las aplicaba sobre una copia vieja → el producto quitado volvía. Ahora van en fila, una
   tras otra, vengan de donde vengan (cajón, PDP, popup, /cart). Tope de 8 s por si una cuelga. */
(function () {
  if (!window.fetch || window.__cmCartQ) return;
  window.__cmCartQ = true;
  var orig = window.fetch, q = Promise.resolve(), RX = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  window.fetch = function (input, init) {
    var args = arguments, url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = String((init && init.method) || (input && typeof input !== 'string' && input.method) || 'GET').toUpperCase();
    if (method !== 'POST' || !RX.test(url)) return orig.apply(window, args);
    return new Promise(function (resolve, reject) {
      q = q.then(function () {
        return new Promise(function (next) {
          var t = setTimeout(next, 8000), r;
          try { r = orig.apply(window, args); } catch (e) { r = Promise.reject(e); }
          r.then(resolve, reject);
          r.then(function () { clearTimeout(t); next(); }, function () { clearTimeout(t); next(); });
        });
      });
    });
  };
})();

/* 15-oct-2026 🏗️ NOIR: el idioma PRINCIPAL de la tienda es inglés → el checkout de Shopify salía en inglés aunque la web esté en español.
   Todo enlace a /checkout (o /discount/…?redirect=/checkout) sale con locale=es. Se reescribe el href al tocar (sin preventDefault). */
(function () {
  function es(h) {
    if (!h || h.indexOf('locale=') > -1) return h;
    if (/^(https?:\/\/[^\/]+)?\/checkout(\b|\/|\?|$)/.test(h)) return h + (h.indexOf('?') > -1 ? '&' : '?') + 'locale=es';
    if (/\/discount\/[^?]+\?redirect=(\/|%2F)checkout/i.test(h)) return h.replace(/redirect=(\/|%2F)checkout(?:(\?|%3F)[^&]*)?/i, 'redirect=%2Fcheckout%3Flocale%3Des');
    return h;
  }
  function fix(e) { var a = e.target && e.target.closest ? e.target.closest('a[href*="checkout"]') : null; if (a) { var h = a.getAttribute('href'), n = es(h); if (n !== h) a.setAttribute('href', n); } }
  document.addEventListener('pointerdown', fix, true);
  document.addEventListener('click', fix, true);
  window.__noirCheckoutES = es;
})();

(function () {
  'use strict';

  /* ---- Header shadow on scroll ---- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Mobile drawer ---- */
  var drawer = document.querySelector('[data-drawer]');
  var openBtn = document.querySelector('[data-drawer-open]');
  var closeEls = document.querySelectorAll('[data-drawer-close]');
  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }
  if (openBtn) openBtn.addEventListener('click', function () { setDrawer(true); });
  closeEls.forEach(function (el) { el.addEventListener('click', function () { setDrawer(false); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setDrawer(false); });

  /* ---- FAQ accordion ---- */
  document.querySelectorAll('[data-faq-q]').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.closest('.faq__item');
      var ans = item.querySelector('.faq__a');
      var open = item.classList.toggle('is-open');
      ans.style.maxHeight = open ? ans.scrollHeight + 'px' : '0';
      q.setAttribute('aria-expanded', open);
    });
  });

  /* ---- Plan selector: subscription (WhatsApp/external) vs one-time (Shopify cart) ---- */
  document.querySelectorAll('[data-plan-group]').forEach(function (group) {
    var opts = group.querySelectorAll('[data-plan]');
    var buyBtn = group.querySelector('[data-buy-button]');

    function applyPlan(opt) {
      opts.forEach(function (o) { o.classList.remove('is-active'); o.setAttribute('aria-checked', 'false'); });
      opt.classList.add('is-active');
      opt.setAttribute('aria-checked', 'true');

      var price = opt.getAttribute('data-price');
      var label = opt.getAttribute('data-label');
      var action = opt.getAttribute('data-action');   // 'cart' | 'whatsapp' | 'external'
      var href = opt.getAttribute('data-href') || '';
      var btnText = opt.getAttribute('data-btn-text');

      group.querySelectorAll('[data-buy-price]').forEach(function (el) { if (price) el.textContent = price; });
      group.querySelectorAll('[data-buy-label]').forEach(function (el) { if (label) el.textContent = label; });

      var stickyPrice = document.querySelector('[data-sticky-price]');
      if (stickyPrice && price) stickyPrice.textContent = price;

      if (buyBtn) {
        buyBtn.setAttribute('data-mode', action || 'cart');
        if (href) buyBtn.setAttribute('data-href', href);
        if (btnText) buyBtn.textContent = btnText;
      }
      // update variant: cart form id + all direct-checkout permalinks (data-buy-link)
      var variantId = opt.getAttribute('data-variant');
      if (variantId) {
        var idInput = group.querySelector('input[name="id"]');
        if (idInput) idInput.value = variantId;
        document.querySelectorAll('[data-buy-link]').forEach(function (a) {
          a.setAttribute('href', '/cart/' + variantId + ':1');
          a.setAttribute('data-variant', variantId);
        });
      }
    }

    opts.forEach(function (opt) {
      opt.addEventListener('click', function () { applyPlan(opt); });
    });

    /* Buy button: cart mode submits the Shopify form; other modes redirect */
    if (buyBtn) {
      buyBtn.addEventListener('click', function (e) {
        var mode = buyBtn.getAttribute('data-mode');
        if (mode && mode !== 'cart') {
          e.preventDefault();
          var href = buyBtn.getAttribute('data-href');
          if (href) window.open(href, '_blank', 'noopener');
        }
        // mode === 'cart' → let the native product form submit (add to cart)
      });
    }
  });

  /* ---- Sticky mobile CTA: show after hero scrolls past ---- */
  var sticky = document.querySelector('[data-sticky-cta]');
  var heroAnchor = document.querySelector('[data-hero]');
  if (sticky && heroAnchor && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        sticky.classList.toggle('is-visible', !e.isIntersecting);
      });
    }, { rootMargin: '-120px 0px 0px 0px' });
    io.observe(heroAnchor);
  }

  /* ---- Scroll reveal ---- */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var ro = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { ro.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---- Product sticky add-to-cart (mobile) ---- */
  var psticky = document.querySelector('[data-psticky]');
  var buySec = document.getElementById('buy');
  if (psticky && buySec && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { psticky.classList.toggle('is-visible', !e.isIntersecting); });
    }, { rootMargin: '-80px 0px 0px 0px' }).observe(buySec);
    var addBtn = psticky.querySelector('[data-psticky-add]');
    if (addBtn) addBtn.addEventListener('click', function () {
      var real = document.querySelector('[data-buy-button]');
      if (real) real.click();
    });
  }

  /* ---- Product image gallery ---- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (main && full) { main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = full; }
        g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---- Diagnostic quiz ---- */
  document.querySelectorAll('[data-quiz]').forEach(function (quiz) {
    var steps = Array.prototype.slice.call(quiz.querySelectorAll('[data-quiz-step]'));
    var result = quiz.querySelector('[data-quiz-result]');
    var bar = quiz.querySelector('[data-quiz-bar]');
    var total = steps.length + 1; // + result
    var idx = 0;

    function render() {
      steps.forEach(function (s, i) { s.classList.toggle('is-active', i === idx && idx < steps.length); });
      if (result) result.classList.toggle('is-active', idx >= steps.length);
      if (bar) bar.style.width = ((idx + 1) / total * 100) + '%';
    }
    function go(n) { idx = Math.max(0, Math.min(steps.length, n)); render(); }

    steps.forEach(function (step, i) {
      step.querySelectorAll('[data-quiz-opt]').forEach(function (opt) {
        opt.addEventListener('click', function () {
          step.querySelectorAll('[data-quiz-opt]').forEach(function (o) { o.classList.remove('is-sel'); });
          opt.classList.add('is-sel');
          setTimeout(function () { go(i + 1); }, 180);
        });
      });
      var back = step.querySelector('[data-quiz-back]');
      if (back) back.addEventListener('click', function () { go(i - 1); });
    });
    // botón WhatsApp del resultado: manda las respuestas elegidas a Hayde
    var waBtn = quiz.querySelector('[data-quiz-wa]');
    if (waBtn) {
      var origGo = go;
      go = function (n) {
        origGo(n);
        if (n >= steps.length) {
          var answers = [];
          steps.forEach(function (s) {
            var q = s.querySelector('.quiz__q'), sel = s.querySelector('.quiz__opt.is-sel');
            if (q && sel) answers.push(q.textContent.trim() + ' → ' + sel.textContent.trim());
          });
          var msg = '¡Hola! Acabo de hacer el quiz de Carmesí 🌷 Mis respuestas:\n' + answers.join('\n') + '\n¿Qué rutina me recomiendas?';
          waBtn.href = 'https://wa.me/' + waBtn.getAttribute('data-wa') + '?text=' + encodeURIComponent(msg);
        }
      };
    }
    var restart = quiz.querySelector('[data-quiz-restart]');
    if (restart) restart.addEventListener('click', function () {
      quiz.querySelectorAll('.quiz__opt.is-sel').forEach(function (o) { o.classList.remove('is-sel'); });
      go(0);
    });
    render();
  });

  /* ---- Smooth anchor scroll for in-page links ---- */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (id.length < 2) return;
      var target = document.querySelector(id);
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); setDrawer(false); }
    });
  });
})();

/* ============================================================
   PREMIUM CART DRAWER — AJAX cart, free-ship/gift bar, upsell, timer
   ============================================================ */
(function () {
  'use strict';
  var root = document.querySelector('[data-cart-drawer]');
  if (!root) return;

  var CUR = root.getAttribute('data-currency') || 'S/';
  var FREE = parseInt(root.getAttribute('data-free-ship'), 10) || 0;       // cents
  var GIFT_ON = root.getAttribute('data-gift-on') === '1';
  var GIFT = parseInt(root.getAttribute('data-gift-threshold'), 10) || 0;  // cents
  var GIFT_TXT = root.getAttribute('data-gift-text') || 'un regalo';
  var TIMER_ON = root.getAttribute('data-timer-on') === '1';
  var TIMER_MIN = parseInt(root.getAttribute('data-timer-min'), 10) || 10;
  var UPSELL_ON = root.getAttribute('data-upsell-on') === '1';
  var GIFT_VID = root.getAttribute('data-gift-vid') || '';
  var GIFT_PID = parseInt(root.getAttribute('data-gift-pid'), 10) || 0;
  var WA = root.getAttribute('data-wa') || '';
  var GIFT2 = parseInt(root.getAttribute('data-gift2-threshold'), 10) || 0;     // cents
  var GIFT2_PID = parseInt(root.getAttribute('data-gift2-pid'), 10) || 0;
  // 08-sep-2026: segundo frasco de regalo al llegar a S/399
  var GIFT2B = parseInt(root.getAttribute('data-gift2b-threshold'), 10) || 0;
  function maxGifts(q) { if (GIFT2B > 0 && q >= GIFT2B) return 2; if (GIFT2 > 0 && q >= GIFT2) return 1; return 0; }
  var ASE_PID = parseInt(root.getAttribute('data-asesoria-pid'), 10) || 0;
  var ASE_VID = parseInt(root.getAttribute('data-asesoria-vid'), 10) || 0;
  var ASE_VAL = parseInt(root.getAttribute('data-asesoria-value'), 10) || 0;
  // 09-sep-2026: plan de asesoría (premio del popup "Eres la clienta N°") → tarjeta de regalo, no producto
  var PLAN_PID = parseInt(root.getAttribute('data-plan-pid'), 10) || 0;
  var PLAN_VAL = parseInt(root.getAttribute('data-plan-value'), 10) || 19900;
  var planBusy = false;
  var GIFT_VAL = parseInt(root.getAttribute('data-gift-value'), 10) || 0;
  // 12-oct-2026 (Manuel): CARRITO LIVIANO — reseñas arriba, UNA línea de regalo (1 frasco «Regalo sorpresa»),
  // productos, UN solo upsell de pack que rota al agregarlo, total y pagar. La escalera sigue cobrando por detrás.
  var LITE = root.getAttribute('data-lite') === '1';
  var GIFT_LITE_VID = parseInt(root.getAttribute('data-gift-lite-vid'), 10) || 0;
  var GIFT_LITE_WAS = parseInt(root.getAttribute('data-gift-lite-was'), 10) || 0;
  var UP_MODE = root.getAttribute('data-up-mode') || 'rotate';
  var giftLiteBusy = false;
  // barra de premios (abajo): Ashwagandha va con su promo propia (3 y 5 frascos), fuera de la escalera
  var AW_PID = parseInt(root.getAttribute('data-aw-pid'), 10) || 0;
  // premios POR MONTO (total que se paga tras la escalera, sin regalos): envío · Regalo Carmesí · 1 frasco
  var PT1 = parseInt(root.getAttribute('data-prog-t1'), 10) || 18900;
  var PT2 = parseInt(root.getAttribute('data-prog-t2'), 10) || 29900;
  var PT3 = parseInt(root.getAttribute('data-prog-t3'), 10) || 39900;
  var carmBusy = false;
  var CMP = {}; try { CMP = JSON.parse(sessionStorage.getItem('cd_cmp') || '{}') || {}; } catch (e) { CMP = {}; }
  var cmpAsked = {};
  function syncCmp(cart) {
    var miss = [];
    cart.items.forEach(function (it) { if (!isGift(it) && CMP[it.variant_id] === undefined && it.handle && !cmpAsked[it.handle]) { cmpAsked[it.handle] = 1; miss.push(it.handle); } });
    if (!miss.length) return;
    Promise.all(miss.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.json(); })
        .then(function (pr) { (pr.variants || []).forEach(function (v) { CMP[v.id] = v.compare_at_price || 0; }); }).catch(function () {});
    })).then(function () {
      cart.items.forEach(function (it) { if (CMP[it.variant_id] === undefined && miss.indexOf(it.handle) >= 0) CMP[it.variant_id] = 0; });
      try { sessionStorage.setItem('cd_cmp', JSON.stringify(CMP)); } catch (e) {}
      fetchCart().then(render);
    });
  }
  function awUnits(cart) { var n = 0; cart.items.forEach(function (it) { if (AW_PID && it.product_id === AW_PID && !isGift(it)) n += it.quantity; }); return n; }
  var AW_TIERS = (root.getAttribute('data-aw-tiers') || '').split(',').map(function (x) { var a = x.split(':'); return { q: parseInt(a[0], 10), p: parseInt(a[1], 10) }; }).filter(function (t) { return t.q && t.p; });
  var DISC_CODE = root.getAttribute('data-disc-code') || '';
  var DISC_PIDS = (root.getAttribute('data-disc-pids') || '').split(',').map(function (x) { return parseInt(x, 10); }).filter(Boolean);
  var DISC_MIN = parseInt(root.getAttribute('data-disc-min'), 10) || 0;   // cents — min cart subtotal for RITUAL40
  // 10-sep-2026 (Manuel): ESCALERA CARMESÍ visible en el carrito — productos a precio regular, una sola línea de descuento,
  // barra de progreso 1·2·3 frascos y tira "completa tu trío". Los descuentos son automáticos de Shopify (2+ = −S/79, 3+ = −S/168).
  var LADDER_PIDS = (root.getAttribute('data-ladder-pids') || '').split(',').map(function (x) { return parseInt(x, 10); }).filter(Boolean);
  var LADDER_T2 = parseInt(root.getAttribute('data-ladder-t2'), 10) || 7900;     // cents
  var LADDER_T3 = parseInt(root.getAttribute('data-ladder-t3'), 10) || 16800;    // cents
  var LADDER_UNIT = parseInt(root.getAttribute('data-ladder-unit'), 10) || 18900; // precio regular de un frasco
  var __ladderUnits = 0;
  function ladderAlloc(it) {
    var s = 0;
    (it.discounts || []).forEach(function (d) { if (/escalera/i.test(d.title || '')) s += (d.amount || 0); });
    if (!s && it.line_level_discount_allocations) it.line_level_discount_allocations.forEach(function (a) {
      var t = (a.discount_application && a.discount_application.title) || ''; if (/escalera/i.test(t)) s += (a.amount || 0);
    });
    return s;
  }
  function isLadderItem(it) { return !isGift(it) && !isSub(it) && (LADDER_PIDS.length ? LADDER_PIDS.indexOf(it.product_id) >= 0 : it.original_price >= 15000); }
  var WELCOME_CODE = root.getAttribute('data-welcome-code') || '';        // store-wide welcome discount (one-time only)
  var WELCOME_PCT = parseInt(root.getAttribute('data-welcome-pct'), 10) || 0;
  var giftBusy = false, gift2Busy = false, aseBusy = false;
  var giftCfg = {};
  try { var gcEl = document.querySelector('[data-gift-config]'); if (gcEl) giftCfg = JSON.parse(gcEl.textContent.trim()); } catch (e) { giftCfg = {}; }
  function isSub(it) { return !!(it.properties && (it.properties.Plan || it.properties['Plan'])); }
  function hoyLima(){
    try{
      var s = new Date().toLocaleDateString('es-PE',{timeZone:'America/Lima',weekday:'long',day:'numeric',month:'long'}).replace(',','');
      return s.charAt(0).toUpperCase()+s.slice(1);
    }catch(e){ return 'hoy'; }
  }
  function isGift(it) { return it.product_id === GIFT_PID || it.product_id === GIFT2_PID || (ASE_PID && it.product_id === ASE_PID) || (PLAN_PID && it.product_id === PLAN_PID); }

  var $ = function (s, c) { return (c || root).querySelector(s); };
  function money(cents) { return CUR + (cents / 100).toFixed(2); }
  function liteName(it) {
    var t = (it.product_title || '').replace('™', '');
    if (!LITE) return t;
    for (var i = 0; i < upsellData.length; i++) if (upsellData[i] && upsellData[i].id === it.product_id && upsellData[i].title) return upsellData[i].title;
    if (t && t === t.toUpperCase()) t = t.toLowerCase().replace(/(^|\s)(\S)/g, function (m, a, b) { return a + b.toUpperCase(); });
    return t;
  }

  var els = {
    items: $('[data-cart-items]'), empty: $('[data-cart-empty]'), foot: $('[data-cart-foot]'),
    count: document.querySelectorAll('[data-cart-count]'), subtotal: $('[data-cart-subtotal]'),
    savings: $('[data-cart-savings]'), rewards: $('[data-cart-rewards]'),
    rewardMsg: $('[data-reward-msg]'), rewardFill: $('[data-reward-fill]'),
    flagShip: $('[data-flag-ship]'), flagGift: $('[data-flag-gift]'), flagGift2: $('[data-flag-gift2]'),
    gifts: $('[data-cart-gifts]'),
    upsell: $('[data-cart-upsell]'), upTrack: $('[data-upsell-track]'),
    desc5: $('[data-cart-desc5]'), desc5btn: $('[data-desc5-go]'),
    timer: $('[data-cart-timer]'), timerClock: $('[data-timer-clock]'),
    checkout: $('[data-cart-checkout]'), checkoutTotal: $('[data-checkout-total]'),
    checkoutLabel: $('[data-checkout-label]'), subNote: $('[data-cart-subnote]'),
    discline: $('[data-cart-discline]'), discamount: $('[data-cart-discamount]'), disclineLabel: $('[data-discline-label]'),
    totalline: $('[data-cart-totalline]'), grandtotal: $('[data-cart-grandtotal]'),
    prog: $('[data-cart-prog]'), progMsg: $('[data-prog-msg]'), progFill: $('[data-prog-fill]'), progSteps: root.querySelectorAll('[data-prog-step]'),
    timerLive: $('[data-timer-live]'), timerDone: $('[data-timer-done]'),
    ladder: $('[data-cart-ladder]'), ladderMsg: $('[data-ladder-msg]'), ladderSteps: root.querySelectorAll('[data-ladder-step]'),
    ladderline: $('[data-cart-ladderline]'), ladderlineLabel: $('[data-ladderline-label]'), ladderamount: $('[data-cart-ladderamount]'),
    added: $('[data-cart-added]')
  };
  var appliedCode = null;
  var cartHasReal = false;
  // 🎰 tragamonedas (02-sep): cupón ganado en la PDP (sessionStorage carmesi_cupon) — manda sobre el 5% y el welcome.
  // Las líneas de regalo ganadas llevan la propiedad _slot=1 y NO dependen del umbral del carrito.
  function slotCupon() { try { var c = JSON.parse(sessionStorage.getItem('carmesi_cupon') || 'null'); return (c && c.code) ? c : null; } catch (e) { return null; } }
  var __cartAttrs = null;
  function isSlotGift(it) { return !!(it && it.properties && it.properties._slot) || !!(__cartAttrs && __cartAttrs.Tragamonedas); }
  var cartIcon = document.querySelector('[data-cart-open]');
  var lastCount = -1, addedT;

  var upsellData = [];
  try {
    var raw = document.querySelector('[data-cart-upsell-data]');
    if (raw) upsellData = JSON.parse(raw.textContent.trim());
  } catch (e) { upsellData = []; }

  /* ---------- open / close ---------- */
  // Robust background scroll lock (iOS-safe): fix the body so the page behind can't scroll/tap-through.
  var scrollLockY = 0;
  // iOS: bloquear touchmove fuera del área scrolleable del drawer (Safari encadena el gesto al fondo)
  var cdTouchBlock = function (e) {
    var sc = e.target && e.target.closest ? e.target.closest('.cd__scroll') : null;
    if (!sc) { e.preventDefault(); return; }
    // en los extremos del scroll interno, frenar el rebote que se propaga a la página
    var atTop = sc.scrollTop <= 0, atBottom = sc.scrollTop + sc.clientHeight >= sc.scrollHeight - 1;
    if ((atTop && cdTouchY < e.touches[0].clientY) || (atBottom && cdTouchY > e.touches[0].clientY)) e.preventDefault();
  };
  var cdTouchY = 0;
  var cdTouchStart = function (e) { if (e.touches && e.touches.length) cdTouchY = e.touches[0].clientY; };
  function lockScroll() {
    scrollLockY = window.scrollY || window.pageYOffset || 0;
    var b = document.body;
    b.style.position = 'fixed';
    b.style.top = '-' + scrollLockY + 'px';
    b.style.left = '0'; b.style.right = '0'; b.style.width = '100%';
    b.style.overflow = 'hidden';
    document.documentElement.style.overscrollBehavior = 'none';
    root.addEventListener('touchstart', cdTouchStart, { passive: true });
    root.addEventListener('touchmove', cdTouchBlock, { passive: false });
  }
  function unlockScroll() {
    var b = document.body;
    b.style.position = ''; b.style.top = ''; b.style.left = ''; b.style.right = ''; b.style.width = ''; b.style.overflow = '';
    document.documentElement.style.overscrollBehavior = '';
    root.removeEventListener('touchstart', cdTouchStart, { passive: true });
    root.removeEventListener('touchmove', cdTouchBlock, { passive: false });
    window.scrollTo(0, scrollLockY);
  }
  function open() { root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false'); lockScroll(); startTimer(); }
  function close() { root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true'); unlockScroll(); }
  root.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });
  document.querySelectorAll('[data-cart-open]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); fetchCart().then(render); open(); });
  });
  // 27-ago: re-render bajo demanda — el cupón del popup (SORPRESA5) se pega al carrito
  // vía un touch de /checkout que puede terminar DESPUÉS de abierto el drawer; la
  // sección dispara este evento al completarse y la línea del 5% aparece sola.
  var __lastPintado = -1;
  document.addEventListener('carmesi:cart-refresh', function () {
    fetchCart().then(function (c) {
      // repintar SOLO si el total cambió (ej. el cupón recién se pegó) — sin esto el
      // drawer se renderizaba 2 veces seguidas al abrir y se sentía sobrecargado.
      if (c.total_price !== __lastPintado) render(c);
    });
  });

  /* ---------- fetch / mutate ---------- */
  function fetchCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

  // Extrae el JSON del carrito devuelto por la Section Rendering API (envuelto en
  // <div id="shopify-section-cart-json" class="shopify-section">{...}</div>).
  function parseCartSection(html) {
    var start = html.indexOf('>') + 1;
    var end = html.lastIndexOf('</div>');
    if (start <= 0 || end < 0 || end <= start) return null;
    try { return JSON.parse(html.slice(start, end)); } catch (e) { return null; }
  }
  function addItem(variantId, qty, props) {
    var item = { id: variantId, quantity: qty || 1 };
    if (props && Object.keys(props).length) item.properties = props;
    // PERF: pedimos el carrito completo (sections=cart-json) EN LA MISMA respuesta del
    // add, para no encadenar un segundo request GET /cart.js (ahorra un round-trip
    // completo en cada "Agregar al carrito"). Si por algo el section no viene bien
    // formado, caemos de vuelta al fetchCart() de siempre — nunca rompe el flujo.
    return fetch('/cart/add.js?sections=cart-json', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item], sections: 'cart-json' })
    }).then(function (r) { return r.json(); }).then(function (resp) {
      var parsed = resp && resp.sections && resp.sections['cart-json'] ? parseCartSection(resp.sections['cart-json']) : null;
      return parsed || fetchCart();
    });
  }

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.ok ? r.json() : fetchCart(); });   // línea que ya no existe (400) → carrito real, no un error que rompe el render
  }

  /* ---------- render ---------- */
  function render(cart) {
    __cartAttrs = cart.attributes || null;   // 🎰 carrito armado por el tragamonedas (permalink)
    __lastPintado = cart.total_price;
    var count = cart.item_count;
    if (LITE) { count = 0; cart.items.forEach(function (it) { if (!isGift(it)) count += it.quantity; }); }   // solo lo que se paga (sin regalo ni asesoría)
    els.count.forEach(function (n) { n.textContent = count; });
    document.querySelectorAll('.cart-count').forEach(function (n) {
      n.textContent = count; n.style.display = count > 0 ? '' : 'none';
    });
    if (cartIcon && lastCount !== -1 && count > lastCount) {
      cartIcon.classList.remove('is-bump'); void cartIcon.offsetWidth; cartIcon.classList.add('is-bump');
    }
    lastCount = count;

    var hasItems = count > 0;
    var hasReal = cart.items.some(function (it) { return !isGift(it); });
    cartHasReal = hasReal;
    if (els.empty) els.empty.hidden = hasItems;
    if (els.foot) els.foot.hidden = !hasItems;
    if (els.rewards) els.rewards.style.display = hasItems ? '' : 'none';
    if (els.items) els.items.style.display = hasItems ? '' : 'none';
    if (els.timer && TIMER_ON) els.timer.hidden = !hasReal;
    if (LITE && TIMER_ON && hasReal && root.classList.contains('is-open')) startTimer();

    // qualifying total = merchandise excluding the free-gift lines
    var qualifying = 0;
    cart.items.forEach(function (it) { if (!isGift(it)) qualifying += it.final_line_price; });

    // line items
    // 🎉 ANIVERSARIO: el BXGY parte la línea (1 pagada + 1 gratis) — fusionamos VISUALMENTE en una sola con cantidad total
    var displayItems = cart.items;
    if (Date.now() < ANIV_END) {
      var mSeen = {}, mList = [];
      cart.items.forEach(function (it) {
        var pp = it.properties || {};
        if (isGift(it) || ANIV_PIDS.indexOf(it.product_id) < 0 || pp._subpct || pp._emb || pp._promo) { mList.push(it); return; }
        if (mSeen[it.variant_id]) {
          var m = mSeen[it.variant_id];
          m.quantity += it.quantity;
          m.final_line_price += it.final_line_price;
          m.original_line_price += it.original_line_price;
          m._anivFree += (it.final_line_price === 0 ? it.quantity : 0);
          m._segs.push({ k: it.key, q: it.quantity });
        } else {
          var cp = {}; for (var kk in it) cp[kk] = it[kk];
          cp._anivFree = (it.final_line_price === 0 ? it.quantity : 0);
          cp._segs = [{ k: it.key, q: it.quantity }];
          mSeen[it.variant_id] = cp; mList.push(cp);
        }
      });
      mList.forEach(function (it) { if (it._segs && it._segs.length > 1) it._anivMerged = true; });
      displayItems = mList;
    }
    // secuencia: premios/regalos ARRIBA, productos comprados abajo
    displayItems = displayItems.filter(isGift).concat(displayItems.filter(function (it) { return !isGift(it); }));
    // 10-sep: escalera — total del descuento y frascos que cuentan
    var ladderTotal = 0; __ladderUnits = 0;
    cart.items.forEach(function (it) { if (isGift(it)) return; ladderTotal += ladderAlloc(it); if (isLadderItem(it)) __ladderUnits += it.quantity; });
    if (els.items) {
      els.items.innerHTML = displayItems.map(function (it) {
        var img = it.image ? '<img loading="lazy" decoding="async" src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') + '" alt="">' : '';
        if (isGift(it)) {
          if (LITE) return ''; // Los beneficios se resumen en una sola línea.   // la asesoría sigue entrando, solo sale de la vista
          if (LITE && it.product_id === GIFT_PID && !isSlotGift(it)) {
            var cImg = (giftCfg.gift1 && giftCfg.gift1.image) ? '<img loading="lazy" decoding="async" src="' + giftCfg.gift1.image + '" alt="">' : '';
            return '' +
              '<div class="cd-item cd-item--gift cd-item--giftlite" data-line-key="' + it.key + '">' +
                '<span class="cd-item__media">' + cImg + '<span class="cd-item__gift-tag">🎁</span></span>' +
                '<div class="cd-item__info"><div class="cd-item__title">Regalo Carmesí GRATIS</div>' +
                '<div class="cd-item__variant">Va de regalo con tu pedido</div></div>' +
                '<div class="cd-item__right"><span class="cd-item__price cd-item__price--zero">' + money(0) + '</span></div>' +
              '</div>';
          }
          if (LITE && it.product_id === GIFT2_PID && !isSlotGift(it)) {
            var gImg = (giftCfg.gift1 && giftCfg.gift1.image) ? '<img loading="lazy" decoding="async" src="' + giftCfg.gift1.image + '" alt="">' : '';
            return '' +
              '<div class="cd-item cd-item--gift cd-item--giftlite" data-line-key="' + it.key + '">' +
                '<span class="cd-item__media">' + gImg + '<span class="cd-item__gift-tag">🎁</span></span>' +
                '<div class="cd-item__info"><div class="cd-item__title">Regalo sorpresa: 1 frasco GRATIS</div>' +
                '<div class="cd-item__variant">Va de regalo con tu pedido</div></div>' +
                '<div class="cd-item__right">' + (GIFT_LITE_WAS > 0 ? '<s class="cd-item__wasfree">' + money(GIFT_LITE_WAS) + '</s>' : '') +
                '<span class="cd-item__price cd-item__price--zero">' + money(0) + '</span></div>' +
              '</div>';
          }
          var giftImg = img;   // la línea del regalo debe mostrar el suplemento elegido, no la imagen genérica
          if (it.product_id === GIFT2_PID && giftCfg.gift2 && giftCfg.gift2.options) {
            var go2 = giftCfg.gift2.options.filter(function (o) { return o.vid === it.variant_id; })[0];
            if (go2 && go2.image) giftImg = '<img loading="lazy" decoding="async" src="' + go2.image + '" alt="">';
          }
          var esAse = (ASE_PID && it.product_id === ASE_PID);
          var esPlan = (PLAN_PID && it.product_id === PLAN_PID);
          var giftName = esPlan ? 'Asesoría nutricional · plan 1 mes'
                       : (it.product_id === GIFT2_PID && it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : it.product_title.replace('™', '');
          var giftSub = esPlan ? ((it.properties && it.properties.Premio) ? (it.properties.Premio + ' · va contigo') : '🎉 Premio de clienta · va contigo')
                       : isSlotGift(it) ? '🎰 Bonus del tragamonedas · va contigo'
                       : it.product_id === GIFT2_PID ? 'Tu suplemento de regalo · va contigo'
                       : (esAse ? ('⏰ Solo hoy ' + hoyLima() + ' · pocas plazas') : 'Regalo desbloqueado · va contigo');
          var giftEmoji = (esAse || esPlan) ? '👩‍⚕️' : '🎁';
          var giftWas = esPlan ? PLAN_VAL : esAse ? ASE_VAL : (it.product_id === GIFT_PID ? GIFT_VAL : 0);
          var giftWasHtml = giftWas > 0 ? '<s class="cd-item__wasfree">' + money(giftWas) + '</s>' : '';
          return '' +
            '<div class="cd-item cd-item--gift" data-line-key="' + it.key + '">' +
              '<span class="cd-item__media">' + giftImg + '<span class="cd-item__gift-tag">' + giftEmoji + '</span></span>' +
              '<div class="cd-item__info">' +
                '<div class="cd-item__title">' + giftName + '</div>' +
                '<div class="cd-item__variant">' + giftSub + '</div>' +
              '</div>' +
              '<div class="cd-item__right">' + giftWasHtml + '<span class="cd-item__free">GRATIS</span></div>' +
            '</div>';
        }
        var subPctLine = (it.properties && it.properties._subpct) ? parseInt(it.properties._subpct, 10) : 0;
        var dispPrice, wasPrice;
        if (subPctLine > 0) {                                  // subscription: show −30% price
          dispPrice = Math.round(it.final_line_price * (100 - subPctLine) / 100);
          wasPrice = it.final_line_price;
        } else {                                               // one-time: show pack MSRP strikethrough
          // 10-sep (Manuel): la línea va a PRECIO REGULAR (sin la escalera prorrateada);
          // la escalera y el cupón se muestran como líneas del resumen, no por producto.
          dispPrice = it.final_line_price + ladderAlloc(it);
          var cmpLine = (it.properties && it.properties._compare) ? parseInt(it.properties._compare, 10) * it.quantity : 0;
          if (LITE && CMP[it.variant_id] > 0) cmpLine = Math.max(cmpLine, CMP[it.variant_id] * it.quantity);   // precio «antes» del producto (compare_at)
          wasPrice = (cmpLine > dispPrice) ? cmpLine : (it.original_line_price > dispPrice ? it.original_line_price : 0);
          if (LITE) {   // 12-oct (Manuel): la línea muestra lo que PAGA (tras la escalera) y tacha el precio de lista
            dispPrice = it.final_line_price;
            // Con descuento de Shopify en la línea tachamos SU precio de lista (3 × 189 = 567, lo mismo que el checkout);
            // sin descuento, el compare_at del producto (2×1 S/378, packs, ofertas).
            wasPrice = it.final_line_price < it.original_line_price ? it.original_line_price : cmpLine;
            if (wasPrice <= dispPrice) wasPrice = 0;
          }
        }
        var was = wasPrice > dispPrice ? '<span class="cd-item__was">' + money(wasPrice) + '</span>' : '';
        if (LITE && wasPrice > dispPrice) was += '<span class="cd-item__save">Ahorras ' + money(wasPrice - dispPrice) + (it.quantity > 1 ? ' · ' + money(Math.round(dispPrice / it.quantity)) + ' c/u' : '') + '</span>';
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
        if (LITE && /^\s*\d+\s*(unidad|unidades|frasco|frascos)\s*$/i.test(variant)) variant = '';   // el selector ya dice la cantidad real
        var planBadge = isSub(it) ? '<div class="cd-item__plan">🔁 ' + (it.properties.Plan || it.properties['Plan']) + '</div>' : '';
        var anivBadge = (it._anivFree > 0) ? '<div class="cd-item__plan">🎉 2x1 Aniversario · ' + it._anivFree + ' GRATIS</div>' : '';
        var mergedAttrs = it._anivMerged ? " data-segs='" + JSON.stringify(it._segs) + "' data-vid=\"" + it.variant_id + "\"" : '';
        return '' +
          '<div class="cd-item" data-line-key="' + it.key + '"' + mergedAttrs + '>' +
            '<a class="cd-item__media" href="' + it.url + '">' + img + '</a>' +
            '<div class="cd-item__info">' +
              '<a class="cd-item__title" href="' + it.url + '">' + liteName(it) + '</a>' +
              (variant ? '<div class="cd-item__variant">' + variant + '</div>' : '') +
              planBadge + anivBadge +
              '<div class="cd-item__qty">' +
                '<button data-qty-dec aria-label="Quitar uno">–</button>' +
                '<span>' + it.quantity + '</span>' +
                '<button data-qty-inc aria-label="Agregar uno">+</button>' +
              '</div>' +
            '</div>' +
            '<div class="cd-item__right">' +
              '<div class="cd-item__price">' + money(dispPrice) + '</div>' + was +
              '<button class="cd-item__remove" data-line-remove>Quitar</button>' +
            '</div>' +
          '</div>';
      }).join('');
      bindLineEvents();
    }

    // subtotal · descuento suscripción (−30%) · total — el carrito muestra el monto con descuento
    var fullSubtotal = 0, subSaved = 0, subPctSeen = 0;
    cart.items.forEach(function (it) {
      if (isGift(it)) return;
      fullSubtotal += it.final_line_price;
      var sp = (it.properties && it.properties._subpct) ? parseInt(it.properties._subpct, 10) : 0;
      if (sp > 0) { subSaved += it.final_line_price - Math.round(it.final_line_price * (100 - sp) / 100); subPctSeen = sp; }
    });
    // discount: subscription (−30% on sub items) OR welcome (−10% on one-time orders, store-wide)
    var discAmount = subSaved, discLabel = 'Suscripción −' + subPctSeen + '%';
    if (subSaved === 0 && WELCOME_CODE && WELCOME_PCT > 0 && fullSubtotal > 0) {
      discAmount = Math.round(fullSubtotal * WELCOME_PCT / 100);
      discLabel = '🎉 ¡Felicidades! −' + WELCOME_PCT + '% aplicado';
    }
    // 27-ago: CUPONES del carrito (ej. SORPRESA5 del popup escalera). Antes el drawer
    // solo sabía de suscripción/welcome y el 5% aplicado NO se veía — la clienta creía
    // que su descuento se perdió. El monto real = subtotal − total_price de /cart.js.
    if (discAmount === 0 && cart.total_price < fullSubtotal) {
      var cartDisc = fullSubtotal - cart.total_price;
      var apps = cart.cart_level_discount_applications || [];
      var code = apps.length ? (apps[0].title || '') : '';
      if (cartDisc > 0) {
        discAmount = cartDisc;
        var sc = slotCupon();
        var d5ss = false; try { d5ss = sessionStorage.getItem('carmesi_desc5') === '1'; } catch (e) {}
        discLabel = (code === 'SORPRESA5' || (!code && d5ss)) ? '🎉 5% EXTRA aplicado (SORPRESA5)'
                  : (sc && (!code || code.toUpperCase() === String(sc.code).toUpperCase())) ? (sc.label || ('🎰 ' + sc.pct + '% EXTRA aplicado')) + ' (' + sc.code + ')'
                  : (code ? 'Descuento ' + code : 'Descuento aplicado');
      }
    }
    var grand = fullSubtotal - discAmount;
    // 10-sep: subtotal a precio regular; la escalera como línea propia
    if (els.subtotal) els.subtotal.textContent = money(fullSubtotal + ladderTotal);
    if (els.ladderline) els.ladderline.hidden = !(ladderTotal > 0);
    if (els.ladderlineLabel) els.ladderlineLabel.textContent = __ladderUnits >= 3 ? '🪜 Escalera Carmesí · 3 frascos' : '🪜 Escalera Carmesí · 2 frascos';
    if (els.ladderamount) els.ladderamount.textContent = '−' + money(ladderTotal);
    if (els.discline) els.discline.hidden = !(discAmount > 0);
    if (els.disclineLabel) els.disclineLabel.textContent = discLabel;
    if (els.discamount) els.discamount.textContent = '−' + money(discAmount);
    if (els.totalline) els.totalline.hidden = !(discAmount > 0 || ladderTotal > 0);
    if (els.grandtotal) els.grandtotal.textContent = money(grand);
    if (LITE) {   // una sola línea «Descuento aplicado» (escalera + cupón + suscripción) y el total siempre
      var allDisc = ladderTotal + discAmount;
      if (els.ladderline) els.ladderline.hidden = true;
      if (els.discline) els.discline.hidden = !(allDisc > 0);
      if (els.disclineLabel) els.disclineLabel.textContent = 'Descuento aplicado';
      if (els.discamount) els.discamount.textContent = '−' + money(allDisc);
      if (els.totalline) els.totalline.hidden = false;
      if (els.subtotal && els.subtotal.parentNode) els.subtotal.parentNode.style.display = allDisc > 0 ? '' : 'none';   // sin descuento, subtotal = total
    }
    renderLadder(__ladderUnits, ladderTotal);
    if (LITE) { renderProg(cart, qualifying); syncCmp(cart); }
    if (els.checkoutTotal) els.checkoutTotal.textContent = count > 0 ? money(grand) : '';
    updateCheckoutMode(cart);
    if (els.savings) {
      // pack savings (one-time items with _compare) — la suscripción se muestra en la línea de descuento
      var packSaved = 0;
      cart.items.forEach(function (it) {
        if (it.properties && it.properties._subpct) return;
        var c = (it.properties && it.properties._compare) ? parseInt(it.properties._compare, 10) * it.quantity : 0;
        if (c > it.final_line_price) packSaved += (c - it.final_line_price);
      });
      var totalSaved = packSaved + ladderTotal + discAmount;
      if (LITE) {
        totalSaved = discAmount;
        cart.items.forEach(function (it) {
          if (isGift(it) || (it.properties && it.properties._subpct)) return;
          var base = Math.max(it.original_line_price, (CMP[it.variant_id] || 0) * it.quantity, (it.properties && it.properties._compare) ? parseInt(it.properties._compare, 10) * it.quantity : 0);
          if (base > it.final_line_price) totalSaved += base - it.final_line_price;
        });
      }
      if (totalSaved > 0) { els.savings.hidden = false; els.savings.textContent = '🎉 Estás ahorrando ' + money(totalSaved); }
      else els.savings.hidden = true;
    }

    renderRewards(qualifying);
    renderGifts(qualifying, cart);
    renderDesc5(cart);
    renderUpsell(cart);
    // En la PÁGINA de carrito (/cart) los regalos los gestiona cart.liquid con SUS umbrales (150/300).
    // Si el drawer también los gestionara (299/399) pelearían → loop. Por eso aquí no.
    if (!document.body.classList.contains('template-cart')) {
      if (syncOrphans(cart)) return;   // 14-oct: carrito sin productos pagados → fuera todas las líneas S/0 de una vez
      if (!LITE) syncGift(cart, qualifying); else syncCarmesiLite(cart, qualifying);
      syncAsesoria(cart, qualifying);
      syncPlan(cart);
      if (LITE) syncGiftLite(cart, qualifying); else syncGift2(cart, qualifying);
    }
  }

  /* ---------- checkout mode: subscription -> WhatsApp, else Shopify ---------- */
  function displayTotal(cart) {
    var t = 0;
    cart.items.forEach(function (it) {
      if (isGift(it)) return;
      var sp = (it.properties && it.properties._subpct) ? parseInt(it.properties._subpct, 10) : 0;
      t += sp > 0 ? Math.round(it.final_line_price * (100 - sp) / 100) : it.final_line_price;
    });
    return t;
  }
  function buildSubMessage(cart) {
    var lines = cart.items.filter(function (it) { return !isGift(it); }).map(function (it) {
      var v = (it.variant_title && it.variant_title !== 'Default Title') ? ' (' + it.variant_title + ')' : '';
      var sp = (it.properties && it.properties._subpct) ? parseInt(it.properties._subpct, 10) : 0;
      var s = sp > 0 ? ' — Suscripción mensual (-' + sp + '%)' : ' — Compra única';
      return '• ' + it.quantity + '× ' + it.product_title.replace('™', '') + v + s;
    });
    var gifts = cart.items.filter(isGift).map(function (it) {
      var nm = (it.product_id === GIFT2_PID && it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : it.product_title.replace('™', '');
      return '• 1× ' + nm + ' — REGALO GRATIS';
    });
    return 'Hola 👋 Quiero coordinar mi pedido con suscripción:\n' + lines.concat(gifts).join('\n') +
      '\n\nTotal con suscripción: ' + money(displayTotal(cart)) + '\n¿Me ayudas a completarlo?';
  }
  function updateCheckoutMode(cart) {
    if (!els.checkout) return;
    var hasSub = cart.items.some(isSub);
    if (hasSub && WA) {
      els.checkout.setAttribute('href', 'https://wa.me/' + WA + '?text=' + encodeURIComponent(buildSubMessage(cart)));
      els.checkout.setAttribute('target', '_blank');
      els.checkout.setAttribute('rel', 'noopener');
      els.checkout.classList.add('cd__checkout--wa');
      if (els.checkoutLabel) els.checkoutLabel.textContent = 'Coordinar suscripción por WhatsApp';
      if (els.checkoutTotal) els.checkoutTotal.style.display = 'none';
      if (els.subNote) els.subNote.hidden = false;
    } else {
      // one-time order: auto-apply the welcome discount (store-wide) so it loads in the cart total + checkout
      var hasReal = cart.items.some(function (it) { return !isGift(it); });
      // 🎉 ANIVERSARIO (julio 2026): con producto 2x1 en el carrito, jamás aplicar welcome (10%) — pisaría el 2x1 (50%).
      var anivNow = Date.now() < ANIV_END;
      var anivInCart = anivNow && cart.items.some(function (it) { return ANIV_PIDS.indexOf(it.product_id) >= 0; });
      // pack 3+/6 de la PDP: su precio de pack se honra en la página /cart (encadena su código) — mandarlo allá
      var anivTierCart = anivNow && cart.items.some(function (it) { return ANIV_PIDS.indexOf(it.product_id) >= 0 && it.quantity >= 3; });
      // carrito de embudo (_emb/_promo/_wonpct): sus descuentos los gestiona la página /cart — jamás pisarlos con el welcome
      var isFunnelCart = cart.items.some(function (it) { var p = it.properties || {}; return p._emb || p._promo || p._main || p._wonpct; });
      if (isFunnelCart || anivTierCart) {
        els.checkout.setAttribute('href', '/cart');
        els.checkout.removeAttribute('target');
        els.checkout.removeAttribute('rel');
        els.checkout.classList.remove('cd__checkout--wa');
        if (els.checkoutLabel) els.checkoutLabel.textContent = 'Ver mi descuento y pagar';
        if (els.checkoutTotal) els.checkoutTotal.style.display = '';
        if (els.subNote) els.subNote.hidden = true;
        return;
      }
      var sc0 = slotCupon();   // 🎰 el cupón del tragamonedas va al checkout aunque la cookie haya fallado
      var code = appliedCode || (sc0 ? sc0.code : null) || (discApplies(cart) ? DISC_CODE : null) || (WELCOME_CODE && hasReal && !anivInCart ? WELCOME_CODE : null);
      // 15-oct-2026 🏗️ hotfix: checkout SIEMPRE en español (idioma principal de la tienda = inglés)
      els.checkout.setAttribute('href', code ? '/discount/' + encodeURIComponent(code) + '?redirect=%2Fcheckout%3Flocale%3Des' : '/checkout?locale=es');
      els.checkout.removeAttribute('target');
      els.checkout.removeAttribute('rel');
      els.checkout.classList.remove('cd__checkout--wa');
      if (els.checkoutLabel) els.checkoutLabel.textContent = 'Finalizar compra';
      if (els.checkoutTotal) els.checkoutTotal.style.display = '';
      if (els.subNote) els.subNote.hidden = true;
    }
  }
  // RITUAL40 only applies when: a complementary product is in cart AND non-gift subtotal >= min AND no subscription
  function nonGiftSubtotal(cart) {
    var s = 0;
    cart.items.forEach(function (it) { if (!isGift(it)) s += it.final_line_price; });
    return s;
  }
  function discApplies(cart) {
    if (!DISC_CODE || !DISC_PIDS.length) return false;
    if (cart.items.some(isSub)) return false;
    var hasComp = cart.items.some(function (it) { return DISC_PIDS.indexOf(it.product_id) >= 0; });
    return hasComp && nonGiftSubtotal(cart) >= DISC_MIN;
  }
  // estimated discount from RITUAL40 (40% off complementary lines), applied at checkout
  function discEstimate(cart) {
    if (!discApplies(cart)) return 0;
    var base = 0;
    cart.items.forEach(function (it) { if (DISC_PIDS.indexOf(it.product_id) >= 0) base += it.final_line_price; });
    return Math.round(base * 0.40);
  }

  /* ---------- auto-gift: add/remove the free gift across the threshold ---------- */
  function syncGift(cart, qualifying) {
    if (!GIFT_ON || !GIFT_VID || !GIFT_PID || giftBusy) return;
    var giftLine = null;
    cart.items.forEach(function (it) { if (it.product_id === GIFT_PID) giftLine = it; });
    if (qualifying >= GIFT && !giftLine) {
      giftBusy = true;
      addItem(GIFT_VID, 1).then(function (c) { giftBusy = false; render(c); })
        .catch(function () { giftBusy = false; });
    } else if (giftLine && qualifying < GIFT) {
      giftBusy = true;
      changeLine(giftLine.key, 0).then(function (c) { giftBusy = false; render(c); })
        .catch(function () { giftBusy = false; });
    }
  }

  /* ---------- 14-oct (Manuel): sin productos pagados no queda ninguna línea S/0 escondida (regalo, frasco, asesoría, plan) ---------- */
  var orphanBusy = false;
  function syncOrphans(cart) {
    if (orphanBusy || !cart.items.length || cart.items.some(function (it) { return !isGift(it); })) return false;
    orphanBusy = true;
    var ups = {}; cart.items.forEach(function (it) { ups[it.key] = 0; });
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: ups }) })
      .then(function (r) { return r.ok ? r.json() : fetchCart(); })
      .then(function (c) { orphanBusy = false; render(c); }).catch(function () { orphanBusy = false; });
    return true;
  }

  /* ---------- plan de asesoría (premio del popup): nunca más de una línea ni cantidad > 1 ---------- */
  function syncPlan(cart) {
    if (!PLAN_PID || planBusy) return;
    var lines = cart.items.filter(function (it) { return it.product_id === PLAN_PID; });
    if (!lines.length) return;
    if (lines.length === 1 && lines[0].quantity === 1) return;
    planBusy = true;
    var chain = Promise.resolve();
    lines.forEach(function (it, ix) { chain = chain.then(function () { return changeLine(it.key, ix === 0 ? 1 : 0); }); });
    chain.then(function (c) { planBusy = false; render(c); }).catch(function () { planBusy = false; });
  }

  /* ---------- asesoría gratis: entra con cualquier compra, en todos los productos ---------- */
  function syncAsesoria(cart, qualifying) {
    if (!ASE_PID || !ASE_VID || aseBusy) return;
    var aseLine = null;
    cart.items.forEach(function (it) { if (it.product_id === ASE_PID) aseLine = it; });
    if (qualifying >= PT2 && !aseLine) {
      aseBusy = true;
      addItem(ASE_VID, 1).then(function (c) { aseBusy = false; render(c); })
        .catch(function () { aseBusy = false; });
    } else if (aseLine && qualifying < PT2) {
      aseBusy = true;
      changeLine(aseLine.key, 0).then(function (c) { aseBusy = false; render(c); })
        .catch(function () { aseBusy = false; });
    }
    else if (aseLine && aseLine.quantity > 1) {   // doble add (buy box + auto): una sola asesoría inicial
      aseBusy = true;
      changeLine(aseLine.key, 1).then(function (c) { aseBusy = false; render(c); })
        .catch(function () { aseBusy = false; });
    }
  }

  /* ---------- rewards / urgency bar (3 hitos: envío 99 · regalo 299 · suplemento 399) ---------- */
  /* ---------- 10-sep: barra de la ESCALERA (1·2·3 frascos de cualquier producto) ---------- */
  function renderLadder(units, ladderTotal) {
    if (!els.ladder) return;
    if (!units) { els.ladder.hidden = true; return; }
    els.ladder.hidden = false;
    var p2 = money(LADDER_UNIT * 2 - LADDER_T2), p3 = money(LADDER_UNIT * 3 - LADDER_T3);
    var msg;
    if (units === 1) msg = 'Tienes <b>1 frasco</b>. Agrega <b>1 más</b> de cualquier producto y ahorras <b>' + money(LADDER_T2) + '</b> · con <b>3</b> ahorras <b>' + money(LADDER_T3) + '</b> (3 frascos por ' + p3 + ')';
    else if (units === 2) msg = '¡Ya ahorras <b>' + money(ladderTotal || LADDER_T2) + '</b>! Agrega <b>1 más</b> y tu trío queda en <b>' + p3 + '</b> (ahorras ' + money(LADDER_T3) + ')';
    else msg = '<span class="done">🎉 <b>Escalera aplicada:</b> 3 frascos por <b>' + p3 + '</b> · ahorras <b>' + money(ladderTotal || LADDER_T3) + '</b></span>' + (units > 3 ? '<small>Del 4º frasco en adelante va a precio regular.</small>' : '');
    if (els.ladderMsg) els.ladderMsg.innerHTML = msg;
    els.ladderSteps.forEach(function (s) { var n = parseInt(s.getAttribute('data-ladder-step'), 10); s.classList.toggle('is-hit', units >= n); s.classList.toggle('is-next', units === n - 1); });
  }

  /* ---------- 12-oct: barra de premios del carrito liviano (solo premios reales) ---------- */
  function renderProg(cart, qualifying) {
    if (!els.prog) return;
    var hasReal = cart.items.some(function (it) { return !isGift(it); });
    if (!hasReal) { els.prog.hidden = true; return; }
    els.prog.hidden = false;
    var aw = 0; cart.items.forEach(function (it) { if (AW_PID && it.product_id === AW_PID && !isGift(it)) aw += it.quantity; });
    var labels, hit, fill, msg;
    if (aw > 0 && AW_TIERS.length >= 2) {
      var t1 = AW_TIERS[0], t2 = AW_TIERS[1];
      labels = ['1', t1.q + ' · ' + money(t1.p).replace('.00', ''), t2.q + ' · ' + money(t2.p).replace('.00', '')];
      hit = [true, aw >= t1.q, aw >= t2.q];
      fill = aw >= t2.q ? 100 : aw >= t1.q ? 50 + 33.3 * (aw - t1.q) / (t2.q - t1.q) : 16.7 + 33.3 * (aw - 1) / (t1.q - 1);
      if (aw < t1.q) msg = 'Agrega <b>' + (t1.q - aw) + ' más</b>: <b>' + t1.q + ' frascos por ' + money(t1.p).replace('.00', '') + '</b> · ' + t2.q + ' por ' + money(t2.p).replace('.00', '');
      else if (aw < t2.q) msg = '✓ ' + t1.q + ' por ' + money(t1.p).replace('.00', '') + ' · agrega <b>' + (t2.q - aw) + ' más</b> y llevas <b>' + t2.q + ' por ' + money(t2.p).replace('.00', '') + '</b>';
      else msg = '<span class="done">🎉 Tienes la mejor oferta: ' + t2.q + ' frascos por ' + money(t2.p).replace('.00', '') + '</span>';
    } else {
      var q = qualifying, m1 = money(PT1).replace('.00', ''), m2 = money(PT2).replace('.00', ''), m3 = money(PT3).replace('.00', '');
      labels = ['🎁 Regalo · ' + m1, '👩‍⚕️ Asesoría · ' + m2, '🎁 Suplemento · ' + m3];
      hit = [q >= PT1, q >= PT2, q >= PT3];
      // pasos centrados en 16.7 % · 50 % · 83.3 %; lleno al 100 % con los 3
      fill = q >= PT3 ? 100 : q >= PT2 ? 50 + 33.3 * (q - PT2) / (PT3 - PT2) : q >= PT1 ? 16.7 + 33.3 * (q - PT1) / (PT2 - PT1) : 16.7 * q / PT1;
      if (q < PT1) msg = 'Te faltan <b>' + money(PT1 - q) + '</b> para tu <b>🎁 Regalo sorpresa</b>';
      else if (q < PT2) msg = '🎁 Regalo sorpresa ✓ · Te faltan <b>' + money(PT2 - q) + '</b> para tu <b>👩‍⚕️ asesoría nutricional</b>';
      else if (q < PT3) msg = '🎁 Regalo sorpresa + 👩‍⚕️ asesoría ✓ · Te faltan <b>' + money(PT3 - q) + '</b> para tu <b>suplemento sorpresa (frasco de 30)</b>';
      else msg = '<span class="done">🎉 Regalo sorpresa + asesoría nutricional + suplemento sorpresa (frasco de 30)</span>';
    }
    if (els.progMsg) els.progMsg.innerHTML = msg;
    if (els.progFill) els.progFill.style.width = Math.max(0, Math.min(100, fill)) + '%';
    els.progSteps.forEach(function (st, i) { st.classList.toggle('is-hit', !!hit[i]); var em = st.querySelector('em'); if (em) em.textContent = labels[i]; });
  }

  function renderRewards(total) {
    if (!els.rewardFill) return;
    var hasG2 = GIFT2 > 0;
    var hasG2B = GIFT2B > GIFT2;
    var max = hasG2B ? GIFT2B : (hasG2 ? GIFT2 : (GIFT_ON && GIFT > FREE ? GIFT : FREE));
    var pct = max > 0 ? Math.min(100, Math.round(total / max * 100)) : 100;
    els.rewardFill.style.width = pct + '%';

    if (max > 0) {
      if (els.flagShip) els.flagShip.style.left = Math.round(FREE / max * 100) + '%';
      if (els.flagGift) els.flagGift.style.left = Math.round(GIFT / max * 100) + '%';
      if (els.flagGift2) els.flagGift2.style.left = (hasG2B ? Math.round(GIFT2 / max * 100) : 100) + '%';
    }
    if (els.flagShip) els.flagShip.classList.toggle('is-hit', total >= FREE);
    if (els.flagGift) els.flagGift.classList.toggle('is-hit', total >= GIFT);
    if (els.flagGift2) { els.flagGift2.style.display = hasG2 ? '' : 'none'; els.flagGift2.classList.toggle('is-hit', total >= GIFT2); }

    var msg;
    if (total < FREE) {
      msg = 'Te faltan <b>' + money(FREE - total) + '</b> para <b>ENVÍO GRATIS</b> 🚚';
    } else if (GIFT_ON && total < GIFT) {
      msg = '✅ ¡Envío gratis! Agrega <b>' + money(GIFT - total) + '</b> y suma tu <b>regalo sorpresa</b> 🎁';
    } else if (hasG2 && total < GIFT2) {
      msg = '🎁 ¡Regalo sorpresa desbloqueado! Agrega <b>' + money(GIFT2 - total) + '</b> y elige un <b>frasco GRATIS</b> 💖';
    } else if (hasG2B && total < GIFT2B) {
      msg = '💖 ¡Tu frasco GRATIS está desbloqueado! Agrega <b>' + money(GIFT2B - total) + '</b> y te llevas <b>DOS frascos gratis</b> 🎁';
    } else {
      msg = '<span class="done">🎉 ¡Lo tienes TODO! Envío gratis + regalo sorpresa + ' + (hasG2B ? '2 frascos' : 'suplemento') + ' GRATIS</span>';
    }
    if (els.rewardMsg) els.rewardMsg.innerHTML = msg;
  }

  /* ---------- gift cards (blurred/locked until unlocked) ---------- */
  function fmt(c) { return money(c); }
  function renderGifts(qualifying, cart) {
    if (!els.gifts) return;
    // hide gift teasers when the cart has no real (non-gift) products
    var hasRealItems = cart.items.some(function (it) { return !isGift(it); });
    if (!hasRealItems) { els.gifts.innerHTML = ''; return; }
    if (LITE) {
      var benefit = qualifying >= PT1 ? '🎁 Regalo sorpresa' : '🎁 Regalo sorpresa desde S/189';
      if (qualifying >= PT2) benefit += ' · 👩‍⚕️ asesoría nutricional';
      if (qualifying >= PT3) benefit += ' · 🎁 suplemento sorpresa (frasco de 30)';
      els.gifts.innerHTML = '<div class="cd-giftlite"><span class="cd-giftlite__t"><b>' + benefit + '</b></span></div>';
      return;
    }
    var html = '';
    // Gift 1 — surprise gift at GIFT (299)
    if (GIFT_ON && GIFT > 0) {
      var g1 = giftCfg.gift1 || {};
      var unlocked1 = qualifying >= GIFT;
      html += giftCard({
        unlocked: unlocked1,
        image: g1.image || '',
        emoji: '🎁',
        title: 'Regalo sorpresa',
        lockedMsg: 'Se libera gastando ' + fmt(GIFT),
        remainMsg: 'Te faltan ' + fmt(GIFT - qualifying),
        unlockedMsg: '¡Desbloqueado! Va GRATIS en tu pedido'
      });
    }
    // Gift 2 — choose-your-free-supplement at GIFT2 (399)
    if (GIFT2 > 0 && giftCfg.gift2 && giftCfg.gift2.options) {
      var slotG = null;
      cart.items.forEach(function (it) { if (it.product_id === GIFT2_PID && isSlotGift(it)) slotG = it; });
      var maxG2 = maxGifts(qualifying);
      var unlocked2 = maxG2 > 0 || !!slotG;   // 🎰 ganado en el tragamonedas: desbloqueado con cualquier pack
      var chosenVids = [];
      cart.items.forEach(function (it) { if (it.product_id === GIFT2_PID) chosenVids.push(it.variant_id); });
      if (!unlocked2) {
        html += giftCard({
          unlocked: false, image: (giftCfg.gift2.options[0] || {}).image || '', emoji: '💖',
          title: 'Suplemento GRATIS a elección',
          lockedMsg: 'Se libera gastando ' + fmt(GIFT2),
          remainMsg: 'Te faltan ' + fmt(GIFT2 - qualifying),
          unlockedMsg: ''
        });
      } else if (slotG) {
        var _sg = (giftCfg.gift2.options.filter(function (o) { return o.vid === slotG.variant_id; })[0] || giftCfg.gift2.options[0] || {});
        var _nSlot = 0; cart.items.forEach(function (it) { if (it.product_id === GIFT2_PID && isSlotGift(it)) _nSlot += it.quantity; });
        html += giftCard({ unlocked: true, image: _sg.image || '', emoji: '🎰', title: (_nSlot > 1 ? _nSlot + ' frascos' : 'Frasco') + ' de regalo del tragamonedas', unlockedMsg: 'Elegido en tu jugada · va GRATIS con tu pedido' });
      } else {
        var faltanG2 = maxG2 - chosenVids.length;
        var subG2 = faltanG2 <= 0
          ? (maxG2 === 2 ? '✓ Tus 2 frascos elegidos' : '✓ Tu frasco elegido')
          : (chosenVids.length === 0
              ? (maxG2 === 2 ? 'Desbloqueado · elige 2' : 'Desbloqueado · elige 1')
              : 'Llevas ' + chosenVids.length + ' de ' + maxG2 + ' · elige ' + faltanG2 + ' más');
        html += '' +
          '<div class="cd-gift cd-gift--choose is-unlocked">' +
            '<div class="cd-gift__head"><span class="cd-gift__emoji">💖</span><div><div class="cd-gift__title">🎉 ¡Ganaste ' + (maxG2 === 2 ? '2 frascos' : '1 frasco') + ' GRATIS!</div><div class="cd-gift__sub done">' + subG2 + '</div></div></div>' +
            '<div class="cd-gift__choices" data-gift2-choices>' +
              giftCfg.gift2.options.map(function (o) {
                var on = chosenVids.indexOf(o.vid) >= 0;
                return '<button type="button" class="cd-gift__opt' + (on ? ' is-chosen' : '') + '" data-gift2="' + o.vid + '">' +
                  '<img loading="lazy" decoding="async" src="' + o.image + '" alt="" loading="lazy"><span>' + o.name + '</span>' +
                  (on ? '<span class="cd-gift__chk">✓</span>' : '') + '</button>';
              }).join('') +
            '</div>' +
          '</div>';
      }
    }
    els.gifts.innerHTML = html;
    els.gifts.querySelectorAll('[data-gift2]').forEach(function (b) {
      b.addEventListener('click', function () { chooseGift2(b.getAttribute('data-gift2'), maxGifts(qualifying)); });
    });
  }
  function giftCard(o) {
    return '' +
      '<div class="cd-gift' + (o.unlocked ? ' is-unlocked' : ' is-locked') + '">' +
        '<div class="cd-gift__media">' +
          (o.image ? '<img src="' + o.image + '" alt="">' : '') +
          (o.unlocked ? '<span class="cd-gift__tag">' + o.emoji + '</span>' : '<span class="cd-gift__lock">🔒</span>') +
        '</div>' +
        '<div class="cd-gift__body">' +
          '<div class="cd-gift__title">' + o.emoji + ' ' + o.title + '</div>' +
          (o.unlocked
            ? '<div class="cd-gift__sub done">' + o.unlockedMsg + '</div>'
            : '<div class="cd-gift__sub"><b>' + o.lockedMsg + '</b></div><div class="cd-gift__remain">' + o.remainMsg + '</div>') +
        '</div>' +
      '</div>';
  }
  function chooseGift2(vid, maxG2) {
    if (gift2Busy) return;
    vid = parseInt(vid, 10);
    if (!maxG2 || maxG2 < 1) maxG2 = 1;
    gift2Busy = true;
    fetchCart().then(function (cart) {
      var existing = cart.items.filter(function (it) { return it.product_id === GIFT2_PID; });
      var keepSlot = existing.some(isSlotGift);   // 🎰 si cambia de regalo, la línea sigue marcada como bonus
      var props = keepSlot ? { 'Regalo': '🎰 Tragamonedas Carmesí', '_slot': '1' } : { 'Regalo': 'Frasco gratis (S/189+)' };
      var yaEsta = existing.filter(function (it) { return it.variant_id === vid; })[0];
      var chain = Promise.resolve();
      if (yaEsta) {                                   // ya elegido -> lo suelta
        chain = chain.then(function () { return changeLine(yaEsta.key, 0); });
        return chain;
      }
      if (existing.length >= maxG2) {                 // lleno -> suelta el primero
        var fuera = existing.slice(0, existing.length - maxG2 + 1);
        fuera.forEach(function (it) { chain = chain.then(function () { return changeLine(it.key, 0); }); });
      }
      return chain.then(function () { return addItem(vid, 1, props); });
    }).then(function (c) { gift2Busy = false; render(c); })
      .catch(function () { gift2Busy = false; });
  }

  /* ---------- gift 2 sync: remove the free supplement if total drops below threshold ---------- */
  function syncGift2(cart, qualifying) {
    if (!GIFT2 || !GIFT2_PID || gift2Busy) return;
    var line = null;
    cart.items.forEach(function (it) { if (it.product_id === GIFT2_PID) line = it; });
    // 🎰 la línea ganada en el tragamonedas no depende del umbral; solo se corrige si se duplicó (doble add)
    if (line && isSlotGift(line)) {
      if (__cartAttrs && __cartAttrs.Tragamonedas) return;   // 🎰 v4: 2 o 3 frascos ganados pueden ser el mismo → la cantidad es real, no un doble add
      if (line.quantity > 1) { gift2Busy = true; changeLine(line.key, 1).then(function (c) { gift2Busy = false; render(c); }).catch(function () { gift2Busy = false; }); }
      return;
    }
    var maxG2 = maxGifts(qualifying);
    var lineas = cart.items.filter(function (it) { return it.product_id === GIFT2_PID && !isSlotGift(it); });
    var total2 = 0; lineas.forEach(function (it) { total2 += it.quantity; });
    if (lineas.length > maxG2 || total2 !== lineas.length) {
      gift2Busy = true;
      var chain = Promise.resolve();
      lineas.forEach(function (it, ix) { chain = chain.then(function () { return changeLine(it.key, ix < maxG2 ? 1 : 0); }); });
      chain.then(function (c) { gift2Busy = false; render(c); }).catch(function () { gift2Busy = false; });
    }
  }

  /* ---------- 12-oct: carrito liviano — UN frasco «Regalo sorpresa» desde el umbral de siempre (GIFT2) ---------- */
  function syncGiftLite(cart, qualifying) {
    if (!GIFT2_PID || !GIFT_LITE_VID || giftLiteBusy || gift2Busy) return;
    if (cart.items.some(function (it) { return it.product_id === GIFT2_PID && isSlotGift(it); })) return;   // 🎰 ya ganó su frasco en el juego
    var lineas = cart.items.filter(function (it) { return it.product_id === GIFT2_PID; });
    var want = qualifying >= PT3 ? 1 : 0;   // Ashwagandha: Regalo sorpresa con cualquier pack
    var total2 = 0; lineas.forEach(function (it) { total2 += it.quantity; });
    if (want === 1 && !lineas.length) {
      giftLiteBusy = true;
      addItem(GIFT_LITE_VID, 1, { 'Regalo': 'Regalo sorpresa' }).then(function (c) { giftLiteBusy = false; render(c); })
        .catch(function () { giftLiteBusy = false; });
    } else if (total2 > want) {
      giftLiteBusy = true;
      var chain = Promise.resolve();
      lineas.forEach(function (it, ix) { chain = chain.then(function () { return changeLine(it.key, ix < want ? 1 : 0); }); });
      chain.then(function (c) { giftLiteBusy = false; render(c); }).catch(function () { giftLiteBusy = false; });
    }
  }

  function syncCarmesiLite(cart, qualifying) {
    if (!GIFT_VID || !GIFT_PID || carmBusy || giftBusy) return;
    var line = null; cart.items.forEach(function (it) { if (it.product_id === GIFT_PID && !isSlotGift(it)) line = it; });
    var want = qualifying >= PT1;
    if (want && !line) {
      carmBusy = true;
      addItem(GIFT_VID, 1).then(function (c) { carmBusy = false; render(c); }).catch(function () { carmBusy = false; });
    } else if (line && (!want || line.quantity > 1)) {
      carmBusy = true;
      changeLine(line.key, want ? 1 : 0).then(function (c) { carmBusy = false; render(c); }).catch(function () { carmBusy = false; });
    }
  }

  /* ---------- 5% sorpresa (SORPRESA5) — solo en el carrito ---------- */
  function desc5Applied(cart) {
    if (window.CarmesiSlotOn) return true;   // 🎰 v2: en las páginas con tragamonedas el 5% no se ofrece
    if (slotCupon()) return true;   // 🎰 ya tiene un cupón mayor: no ofrecer el 5%
    try { if (sessionStorage.getItem('carmesi_desc5') === '1') return true; } catch (e) {}
    var apps = (cart && cart.cart_level_discount_applications) || [];
    return apps.some(function (a) { return (a.title || '').toUpperCase() === 'SORPRESA5'; });
  }
  var desc5Bound = false;
  function renderDesc5(cart) {
    if (!els.desc5) return;
    var hasReal = cart.items.some(function (it) { return !isGift(it); });
    els.desc5.hidden = !(hasReal && !desc5Applied(cart));
    if (!desc5Bound && els.desc5btn) {
      desc5Bound = true;
      els.desc5btn.addEventListener('click', function () {
        els.desc5btn.classList.add('is-loading');
        els.desc5btn.textContent = 'Aplicando…';
        try { sessionStorage.setItem('carmesi_desc5', '1'); } catch (e) {}
        function done() { window.CarmesiCart.refresh(); setTimeout(function () { window.CarmesiCart.refresh(); }, 700); }
        fetch('/discount/SORPRESA5', { mode: 'no-cors' }).then(done, done);
      });
    }
  }

  /* ---------- upsell (RHO style list + −40% via RITUAL40) ---------- */
  function renderUpsell(cart) {
    if (!UPSELL_ON || !els.upTrack) return;
    // only show the upsell when the customer has real (non-gift) products in the cart
    var hasRealItems = cart.items.some(function (it) { return !isGift(it); });
    if (!hasRealItems) { els.upsell.hidden = true; return; }
    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.product_id] = true; });
    var pool = upsellData.filter(function (p) { return p && p.available && !inCart[p.id]; });
    if (!pool.length) { els.upsell.hidden = true; return; }
    els.upsell.hidden = false;

    function offPct(p) { return (p.compare && p.compare > p.price) ? Math.round((1 - p.price / p.compare) * 100) : 0; }
    function priceHtml(p, withOff) {
      var pct = offPct(p);
      return '<span class="cd-up__now">' + money(p.price) + '</span>' +
        (pct > 0 ? '<span class="cd-up__was">' + money(p.compare) + '</span>' + (withOff ? '<span class="cd-up__off">−' + pct + '%</span>' : '') : '');
    }
    function addBtn(p, label) {
      return '<button class="cd-up__add" data-up-add="' + p.vid + '" data-up-qty="' + (p.qty || 1) + '"><span>' + (label || 'Agregar') + '</span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></button>';
    }

    var feat = null, rest = [];
    if (LITE && UP_MODE === 'rotate') { feat = pool[0]; }
    else pool.forEach(function (p) { if (p.feat && !feat) { feat = p; } else { rest.push(p); } });

    var html = '';
    if (feat) {
      html += '<div class="cd-up__feat">' +
        (feat.tag ? '<span class="cd-up__feat-ribbon">' + feat.tag + '</span>' : '') +
        '<a class="cd-up__feat-media" href="' + feat.url + '"><img src="' + feat.image + '" alt="" loading="lazy"></a>' +
        '<div class="cd-up__feat-info">' +
          '<a class="cd-up__feat-t" href="' + feat.url + '">' + feat.title + '</a>' +
          (feat.sub ? '<span class="cd-up__feat-sub">' + feat.sub + '</span>' : '') +
          '<div class="cd-up__p">' + priceHtml(feat, true) + '</div>' +
          addBtn(feat, (LITE && UP_MODE !== 'rotate') ? 'Agregar' : 'Agregar el pack') +
        '</div>' +
      '</div>';
    }
    if (rest.length) {
      html += '<div class="cd-up__strip">' + rest.map(function (p) {
        var pct = offPct(p);
        // 10-sep: en los productos de la escalera el badge dice cuánto falta para el trío (no el −% del compare)
        var isLad = !LITE && (LADDER_PIDS.length ? LADDER_PIDS.indexOf(p.id) >= 0 : false);
        var badge = isLad ? (__ladderUnits === 2 ? '¡Completa tu trío · ' + money(LADDER_UNIT * 3 - LADDER_T3) + '!' : __ladderUnits === 1 ? '+2 = trío ' + money(LADDER_UNIT * 3 - LADDER_T3) : __ladderUnits === 0 ? '3 frascos ' + money(LADDER_UNIT * 3 - LADDER_T3) : '') : (pct > 0 ? '−' + pct + '%' : '');
        return '<div class="cd-up">' +
          (badge ? '<span class="cd-up__badge' + (isLad ? ' cd-up__badge--lad' : '') + '">' + badge + '</span>' : '') +
          '<a class="cd-up__media" href="' + p.url + '"><img src="' + p.image + '" alt="" loading="lazy"></a>' +
          '<div class="cd-up__info">' +
            '<a class="cd-up__t" href="' + p.url + '">' + p.title + '</a>' +
            '<div class="cd-up__p">' + priceHtml(p, false) + '</div>' +
          '</div>' +
          addBtn(p) +
        '</div>';
      }).join('') + '</div>';
    }
    els.upTrack.innerHTML = html;

    els.upTrack.querySelectorAll('[data-up-add]').forEach(function (b) {
      b.addEventListener('click', function () {
        b.classList.add('is-loading');
        var sp = b.querySelector('span'); if (sp) sp.textContent = 'Agregado';
        handleAdd(b.getAttribute('data-up-add'), null, parseInt(b.getAttribute('data-up-qty'), 10) || 1);
      });
    });
  }

  /* ---------- line item events ---------- */
  function bindLineEvents() {
    els.items.querySelectorAll('.cd-item').forEach(function (row) {
      var key = row.getAttribute('data-line-key');
      var inc = row.querySelector('[data-qty-inc]');
      var dec = row.querySelector('[data-qty-dec]');
      var rem = row.querySelector('[data-line-remove]');
      if (!inc || !dec || !rem) return; // gift row has no controls
      var segsRaw = row.getAttribute('data-segs');
      if (segsRaw) {
        var mvid = row.getAttribute('data-vid');
        var segs = []; try { segs = JSON.parse(segsRaw); } catch (e) {}
        inc.addEventListener('click', function () { row.style.opacity = '.55'; addItem(mvid, 1).then(function (c) { render(c); }); });
        dec.addEventListener('click', function () {
          row.style.opacity = '.55';
          // FIX 2x1: NO asumir cuál de las 2 sub-líneas (pagada/gratis) es la "última" —
          // ese orden no está garantizado. Consolidamos toda la cantidad restante en UNA
          // sola línea y vaciamos el resto, así Shopify siempre recalcula el 2x1 desde cero
          // (nunca queda una línea "gratis" huérfana con descuento pegado a 1 sola unidad).
          var total = 0; segs.forEach(function (s) { total += s.q; });
          var newQty = Math.max(0, total - 1);
          var ups = {}; segs.forEach(function (s, i) { ups[s.k] = i === 0 ? newQty : 0; });
          fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: ups }) })
            .then(function (r) { return r.json(); }).then(function (c) { render(c); });
        });
        rem.addEventListener('click', function () {
          row.style.opacity = '.4';
          var ups = {}; segs.forEach(function (s) { ups[s.k] = 0; });
          fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: ups }) })
            .then(function () { return fetchCart(); }).then(function (c) { render(c); });
        });
        return;
      }
      var q = parseInt(row.querySelector('.cd-item__qty span').textContent, 10);
      inc.addEventListener('click', function () { row.style.opacity = '.55'; mutate(key, q + 1); });
      dec.addEventListener('click', function () { row.style.opacity = '.55'; mutate(key, q - 1); });
      rem.addEventListener('click', function () { row.style.opacity = '.4'; mutate(key, 0); });
    });
  }
  function mutate(key, qty) { changeLine(key, qty).then(function (c) { render(c); }); }

  /* ---------- reservation timer ---------- */
  var timerInt;
  function startTimer() {
    if (!TIMER_ON || !els.timer || !els.timerClock) return;
    if (!cartHasReal) { els.timer.hidden = true; return; }
    els.timer.hidden = false;
    var KEY = 'cd_timer_start';
    var start = parseInt(sessionStorage.getItem(KEY), 10);
    if (!start) { start = Date.now(); sessionStorage.setItem(KEY, start); }
    var total = TIMER_MIN * 60 * 1000;
    function tick() {
      var left = Math.max(0, total - (Date.now() - start));
      var m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
      els.timerClock.textContent = (LITE && m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      if (LITE && els.timerLive && els.timerDone) { els.timerLive.hidden = left <= 0; els.timerDone.hidden = left > 0; }
      if (left <= 0) { clearInterval(timerInt); if (!LITE) sessionStorage.removeItem(KEY); }   // liviano: queda «venció» en la sesión, el carrito no se toca
    }
    clearInterval(timerInt); tick(); timerInt = setInterval(tick, 1000);
  }

  /* ---------- intercept add-to-cart triggers ---------- */
  // 🎉 ANIVERSARIO 2x1 (solo julio 2026): al agregar impar se completa el par — la unidad extra sale GRATIS por el BXGY. Caduca solo.
  var ANIV_END = Date.parse('2026-08-01T04:59:59Z');
  var ANIV_VIDS = [46040765333743,46470905069807,46470912999663,46470910509295,46046791958767,49614910849263,48781728317679,49692124119279,49614888501487,49692123922671,49692124250351,49692124184815,49692123889903,49716738261231,49716750188783,49692124152047,49716715880687,49716741210351,50142225465583];
  var ANIV_PIDS = [8817012080879,8963781263599,8963786342639,8963785261295,8819382747375,9404507128047,9352531738863,9417273114863,9404498772207,9417272983791,9417273245935,9417273180399,9417272951023,9421606289647,9421607305455,9417273147631,9421605241071,9421606748399,9453913800943];
  function anivEligible(props) {
    if (Date.now() >= ANIV_END) return false;
    if (props && (props.Plan || props._emb || props._promo || props._main || props._wonpct)) return false;
    return true;
  }
  function handleAdd(variantId, btn, qtyOverride) {
    if (!variantId) return;
    var props = null;
    if (btn) {
      var raw = btn.getAttribute('data-props');
      if (raw) { try { props = JSON.parse(raw); } catch (e) { props = null; } }
    }
    var isSubAdd = !!(props && props.Plan);   // subscription → drawer (it routes checkout to WhatsApp)
    var qty = qtyOverride || (btn && parseInt(btn.getAttribute('data-qty'), 10)) || 1;
    // 🎉 fast-pair: variante de aniversario en compra orgánica → el par completo en UNA sola llamada
    var fastPair = qty === 1 && anivEligible(props) && ANIV_VIDS.indexOf(parseInt(variantId, 10)) >= 0;
    if (fastPair) qty = 2;
    if (btn) btn.classList.add('is-loading');
    open();   // feedback INSTANTÁNEO: el drawer abre ya, el contenido llega enseguida
    // PERF: feedback optimista del contador ANTES de que llegue la red -- se corrige
    // solo (render real la pisa) si acierta, y se revierte en el catch si el add falla.
    var optimisticBump = 0;
    if (els.count && els.count.length) {
      optimisticBump = qty;
      els.count.forEach(function (n) { n.textContent = (parseInt(n.textContent, 10) || 0) + optimisticBump; n.style.display = ''; });
      if (cartIcon) { cartIcon.classList.remove('is-bump'); void cartIcon.offsetWidth; cartIcon.classList.add('is-bump'); }
    }
    addItem(variantId, qty, props).then(function (c) {
      if (btn) { btn.classList.remove('is-loading'); btn.classList.add('atc-flash'); setTimeout(function () { btn.classList.remove('atc-flash'); }, 500); }
      if (fastPair) { render(c); showAdded('\uD83C\uDF89 Por aniversario: \u00A1te llevas 2 y pagas 1!'); return; }
      var line = null;
      (c.items || []).forEach(function (it) { if (it.variant_id === Number(variantId)) line = it; });
      var needsPair = !isSubAdd && qty === 1 && anivEligible(props) && line && ANIV_PIDS.indexOf(line.product_id) >= 0 && (line.quantity % 2) === 1;
      if (needsPair) {
        return addItem(variantId, 1, props).then(function (c2) {
          render(c2); showAdded('\uD83C\uDF89 Por aniversario: \u00A1te llevas 2 y pagas 1!');
        });
      }
      render(c); showAdded();
    }).catch(function () {
      if (btn) btn.classList.remove('is-loading');
      if (optimisticBump && els.count) {
        els.count.forEach(function (n) { n.textContent = Math.max(0, (parseInt(n.textContent, 10) || 0) - optimisticBump); });
      }
    });
  }
  var addedDefaultHTML = null;
  function showAdded(msg) {
    if (!els.added) return;
    if (addedDefaultHTML === null) addedDefaultHTML = els.added.innerHTML;
    els.added.innerHTML = msg ? msg : addedDefaultHTML;
    els.added.hidden = false;
    clearTimeout(addedT);
    addedT = setTimeout(function () { els.added.hidden = true; }, msg ? 3600 : 2600);
  }

  /* ---------- discount code ---------- */
  (function () {
    var toggle = root.querySelector('[data-disc-toggle]'), row = root.querySelector('[data-disc-row]'),
        input = root.querySelector('[data-disc-input]'), apply = root.querySelector('[data-disc-apply]'),
        msg = root.querySelector('[data-disc-msg]');
    if (!toggle || !apply) return;
    toggle.addEventListener('click', function () {
      row.hidden = !row.hidden; if (!row.hidden) input.focus();
    });
    function doApply() {
      var code = (input.value || '').trim().toUpperCase();
      if (!code) return;
      appliedCode = code;
      input.value = code;
      msg.hidden = false; msg.className = 'cd__disc-msg ok';
      msg.textContent = '✓ Código "' + code + '" se aplicará en el checkout';
      fetchCart().then(render);
    }
    apply.addEventListener('click', doApply);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); doApply(); } });
  })();

  // product-card quick-add + any [data-atc] element with data-variant
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-atc]');
    if (t) {
      e.preventDefault();
      handleAdd(t.getAttribute('data-variant') || t.getAttribute('data-atc'), t);
      return;
    }
    // raw cart permalinks anywhere (pack CTAs, final-cta, etc.) → add + go to OUR cart page,
    // NOT straight to checkout. Skip /discount links (need the code) and the TikTok funnel ([data-ttk] handles itself).
    var lnk = e.target.closest('a[href*="/cart/"]');
    // 28-ago FIX DOBLE-AGREGADO: los CTA de escalera ([data-esc-cta]) ya agregan vía su
    // propia sección; su href /cart/vid:qty es SOLO respaldo sin-JS. Interceptarlos aquí
    // duplicaba: 1 tap = 3+3 = 6 (caso real de Manuel con Hair Growth).
    if (lnk && !lnk.closest('[data-ttk]') && !lnk.hasAttribute('data-esc-cta') && !lnk.hasAttribute('data-esc-add')) {
      var hr = lnk.getAttribute('href') || '';
      if (hr.indexOf('/discount/') === -1) {
        var mm = hr.match(/\/cart\/(\d+):(\d+)/);
        if (mm) { e.preventDefault(); handleAdd(mm[1], lnk, parseInt(mm[2], 10)); }
      }
    }
  });

  // main-product native form → intercept submit
  document.querySelectorAll('form[action*="/cart/add"], #buy-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = form.querySelector('[name="id"]');
      handleAdd(id && id.value, form.querySelector('[type="submit"]'));
    });
  });

  /* ---------- public API for the funnel (post-add popup, TikTok banner) ---------- */
  window.CarmesiCart = {
    addItem: function (vid, qty, props) { return addItem(vid, qty || 1, props || null).then(function (c) { render(c); return c; }); },
    open: function () { open(); },
    refresh: function () { return fetchCart().then(render); }
  };

  /* ---------- init: sync header count ---------- */
  fetchCart().then(function (c) { render(c); });
})();

/* ============================================================
   SOCIAL PROOF TOASTER — "alguien acaba de comprar"
   ============================================================ */
(function () {
  'use strict';
  var el = document.querySelector('[data-social-proof]');
  if (!el) return;
  if (sessionStorage.getItem('sp_off')) return;
  var names = [], quotes = [];
  try { names = JSON.parse(el.querySelector('[data-sp-names]').textContent.trim()); } catch (e) {}
  try { quotes = JSON.parse(el.querySelector('[data-sp-quotes]').textContent.trim()); } catch (e) {}
  if (!names.length) return;
  var product = el.getAttribute('data-product') || 'Multi Colágeno';
  var interval = (parseInt(el.getAttribute('data-interval'), 10) || 14) * 1000;
  var elName = el.querySelector('[data-sp-name]'), elPlace = el.querySelector('[data-sp-place]'),
      elAv = el.querySelector('[data-sp-av]'), elTime = el.querySelector('[data-sp-time]'),
      elLine = el.querySelector('[data-sp-line]'), elTag = el.querySelector('[data-sp-tag]');
  var tagPurchase = elTag ? elTag.innerHTML : '';
  // 28-ago: contador REAL de pedidos del día (endpoint público del panel, cache 5min).
  var pedidosHoy = null;
  fetch('https://carmesi-whatsapp.vercel.app/api/public/pedidos-hoy')
    .then(function(r){ return r.json(); })
    .then(function(j){ if (j && j.ok && j.hoy >= 3) pedidosHoy = j.hoy; })
    .catch(function(){});
  var shown = 0, MAX = 9, hideT, loopT, lastIdx = -1;
  function rnd(a, b) { return Math.floor(a + (b - a + 1) * Math.random()); }
  function pickName() {
    var idx;
    do { idx = rnd(0, names.length - 1); } while (idx === lastIdx && names.length > 1);
    lastIdx = idx;
    return names[idx];
  }
  function show() {
    if (document.hidden) { schedule(); return; }
    if (shown >= MAX) return;
    shown++;
    var full = pickName();
    var parts = full.split(' ');
    var first = parts.shift();
    elName.textContent = first;
    elPlace.textContent = parts.join(' ');
    if (elAv) elAv.textContent = first.charAt(0).toUpperCase();
    // 1 de cada 3 toasts = reseña 5★; el resto = compra reciente
    var isReview = quotes.length && shown % 3 === 0;
    if (isReview) {
      elLine.innerHTML = '<span class="sp__stars">★★★★★</span> «' + quotes[rnd(0, quotes.length - 1)] + '»';
      if (elTag) elTag.innerHTML = 'Reseña de clienta';
      elTime.textContent = 'hace ' + rnd(1, 5) + ' días';
    } else {
      elLine.innerHTML = 'acaba de comprar <b>' + product + '</b>' +
        (pedidosHoy ? ' <span class="sp__hoy">· 🔥 ' + pedidosHoy + ' pedidos hoy</span>' : '');
      if (elTag) elTag.innerHTML = tagPurchase;
      elTime.textContent = shown === 1 ? 'hace unos minutos' : 'hace ' + rnd(4, 49) + ' min';
    }
    el.classList.add('is-show');
    clearTimeout(hideT);
    hideT = setTimeout(function () { el.classList.remove('is-show'); }, 5600);
    schedule();
  }
  function schedule() {
    clearTimeout(loopT);
    // intervalo con variación natural (±40%)
    var jitter = interval * (0.6 + Math.random() * 0.8);
    loopT = setTimeout(show, jitter);
  }
  el.querySelector('[data-sp-close]').addEventListener('click', function () {
    el.classList.remove('is-show'); sessionStorage.setItem('sp_off', '1'); clearTimeout(loopT); clearTimeout(hideT);
  });
  setTimeout(show, 7000);
})();

/* ============================================================
   CUTOFF DE ENVÍO — "pide antes de las 4 pm y sale hoy" (real)
   ============================================================ */
(function () {
  'use strict';
  var nodes = document.querySelectorAll('[data-cutoff]');
  if (!nodes.length) return;
  function update() {
    // Hora de Perú (UTC-5, sin DST): desplaza el reloj local para que getHours() dé la hora de Lima
    var now = new Date(Date.now() + (new Date().getTimezoneOffset() - 300) * 60000);
    nodes.forEach(function (n) {
      var hour = parseInt(n.getAttribute('data-hour'), 10) || 16;
      var cut = new Date(now); cut.setHours(hour, 0, 0, 0);
      if (now < cut) {
        var ms = cut - now, h = Math.floor(ms / 3600000), m = Math.floor(ms % 3600000 / 60000);
        n.innerHTML = 'Pide en <b>' + (h > 0 ? h + ' h ' : '') + m + ' min</b> y tu pedido sale hoy';
      } else {
        n.textContent = 'Pide ahora y tu pedido sale mañana temprano';
      }
    });
  }
  update();
  setInterval(update, 60000);
})();

/* ============================================================
   PROMO POPUP — auto discount, once per session
   ============================================================ */
(function () {
  'use strict';
  var el = document.querySelector('[data-promo]');
  if (!el) return;
  if (sessionStorage.getItem('promo_seen')) return;
  var delay = (parseInt(el.getAttribute('data-delay'), 10) || 6) * 1000;
  var opened = false;
  function open() {
    if (opened) return; opened = true;
    sessionStorage.setItem('promo_seen', '1');
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
  }
  function close() { el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); }
  el.querySelectorAll('[data-promo-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  var t = setTimeout(open, delay);
  // exit-intent (desktop)
  document.addEventListener('mouseout', function (e) {
    if (!opened && e.clientY <= 0) { clearTimeout(t); open(); }
  });
  // captura de email → revela el código (paso 1 → paso 2)
  var step1 = el.querySelector('[data-promo-step1]'), step2 = el.querySelector('[data-promo-step2]'),
      form = el.querySelector('[data-promo-form]');
  function reveal() {
    if (step1) step1.hidden = true;
    if (step2) step2.hidden = false;
    localStorage.setItem('promo_unlocked', '1');
  }
  if (localStorage.getItem('promo_unlocked')) reveal();
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.disabled = true; btn.textContent = 'Un momento…'; }
    var fd = new FormData(form);
    fetch('/contact', { method: 'POST', body: fd, headers: { 'Accept': 'text/html' } })
      .then(reveal, reveal); // pase lo que pase, el código se revela
  });
  // copy code
  var codeBtn = el.querySelector('[data-promo-code]');
  if (codeBtn) codeBtn.addEventListener('click', function () {
    var code = codeBtn.getAttribute('data-promo-code');
    var done = function () { codeBtn.classList.add('copied'); codeBtn.querySelector('.promo__copy').textContent = '¡Copiado!'; };
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
  });
})();

/* ============================================================
   COUNT-UP — animate stat numbers when they scroll into view
   ============================================================ */
(function () {
  'use strict';
  var nodes = document.querySelectorAll('.study__big, .stat__num, .reviews__score');
  if (!nodes.length || !('IntersectionObserver' in window)) return;
  function animate(node) {
    var raw = node.textContent.trim();
    var m = raw.match(/^([\d.,]+)(.*)$/);
    if (!m) return;
    var suffix = m[2], numStr = m[1].replace(/,/g, '');
    var target = parseFloat(numStr);
    if (isNaN(target)) return;
    var decimals = (numStr.split('.')[1] || '').length;
    var dur = 1100, t0 = null;
    function fmt(v) {
      var s = decimals ? v.toFixed(decimals) : Math.round(v).toString();
      if (!decimals && v >= 1000) s = Math.round(v).toLocaleString('en-US');
      return s + suffix;
    }
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      var eased = 1 - Math.pow(1 - p, 3);
      node.textContent = fmt(target * eased);
      if (p < 1) requestAnimationFrame(step); else node.textContent = fmt(target);
    }
    requestAnimationFrame(step);
  }
  var io = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (e) { if (e.isIntersecting) { animate(e.target); obs.unobserve(e.target); } });
  }, { threshold: 0.5 });
  nodes.forEach(function (n) { io.observe(n); });
})();

/* ============================================================
   URGENCY COUNTDOWN — end-of-day or fixed-minutes (persistent)
   ============================================================ */
(function () {
  'use strict';
  var els = document.querySelectorAll('[data-countdown]');
  if (!els.length) return;
  els.forEach(function (el, i) {
    var mins = parseInt(el.getAttribute('data-mins'), 10) || 0;
    var h = el.querySelector('[data-cd-h]'), m = el.querySelector('[data-cd-m]'), s = el.querySelector('[data-cd-s]');
    if (!h || !m || !s) return;
    var target;
    if (mins > 0) {
      var key = 'urg_' + i + '_' + mins;
      var start = parseInt(sessionStorage.getItem(key), 10);
      if (!start) { start = Date.now(); sessionStorage.setItem(key, start); }
      target = start + mins * 60000;
    } else {
      var d = new Date(); d.setHours(23, 59, 59, 999); target = d.getTime();
    }
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var left = target - Date.now();
      if (left <= 0) {
        if (mins === 0) { var nd = new Date(); nd.setHours(23, 59, 59, 999); target = nd.getTime(); left = target - Date.now(); }
        else left = 0;
      }
      var hh = Math.floor(left / 3600000), mm = Math.floor((left % 3600000) / 60000), ss = Math.floor((left % 60000) / 1000);
      h.textContent = pad(hh); m.textContent = pad(mm); s.textContent = pad(ss);
    }
    tick(); setInterval(tick, 1000);
  });
})();

/* ============================================================
   BUY PACKS — quantity discount cards + subscription frequency
   ============================================================ */
(function () {
  'use strict';
  var root = document.querySelector('[data-buypacks]');
  if (!root) return;
  var wa = root.getAttribute('data-wa') || '';
  var subPct = parseInt(root.getAttribute('data-subpct'), 10) || 15;
  var product = root.getAttribute('data-product') || '';
  var packs = Array.prototype.slice.call(root.querySelectorAll('[data-pack]'));
  var freqs = Array.prototype.slice.call(root.querySelectorAll('[data-freq]'));
  var cta = root.querySelector('[data-bp-cta]');
  var subWas = root.querySelector('[data-sub-was]'), subNow = root.querySelector('[data-sub-now]'), onceNow = root.querySelector('[data-once-now]');
  if (!packs.length) return;
  function money(c) { return 'S/' + (c / 100).toFixed(2); }
  var sel = (root.getAttribute('data-deffirst') === '1' ? packs[0] : null) || (root.getAttribute('data-defbest') === '1' ? packs[packs.length - 1] : null) || packs.find(function (p) { return p.querySelector('.bp__ribbon--pop'); }) || packs[0];
  var freq = freqs.length ? 'sub' : 'once';
  var freqBlock = root.querySelector('.bp__freq');
  var freqLabel = freqBlock ? freqBlock.previousElementSibling : null;

  function setPack(p) {
    sel = p;
    packs.forEach(function (x) { x.classList.toggle('is-active', x === p); });
    var price = parseInt(p.getAttribute('data-price'), 10);
    var comp = parseInt(p.getAttribute('data-compare'), 10) || 0;
    var bigNow = root.querySelector('[data-bp-now]'), bigWas = root.querySelector('[data-bp-was]'), bigOff = root.querySelector('[data-bp-offbig]');
    if (bigNow) bigNow.textContent = money(price);
    if (bigWas) { if (comp > price) { bigWas.textContent = money(comp); bigWas.hidden = false; } else bigWas.hidden = true; }
    if (bigOff) { if (comp > price) { bigOff.textContent = '\u2212' + Math.round((comp - price) * 100 / comp) + '%'; bigOff.hidden = false; } else bigOff.hidden = true; }
    if (subWas) subWas.textContent = money(price);
    if (subNow) subNow.textContent = money(Math.round(price * (100 - subPct) / 100));
    if (onceNow) onceNow.textContent = money(price);
    // best-value pack: no subscription, straight to purchase (like RHO)
    var noSub = p.getAttribute('data-nosub') === '1';
    if (freqBlock) {
      freqBlock.style.display = noSub ? 'none' : '';
      if (freqLabel && freqLabel.classList.contains('bp__label')) freqLabel.style.display = noSub ? 'none' : '';
      if (noSub) { freq = 'once'; }
      else if (freq === 'once') { freq = 'sub'; setFreqActive('sub'); }
    }
    updateCta();
  }
  function setFreqActive(f) { freqs.forEach(function (x) { x.classList.toggle('is-active', x.getAttribute('data-freq') === f); }); }
  function setFreq(f) {
    freq = f;
    freqs.forEach(function (x) { x.classList.toggle('is-active', x.getAttribute('data-freq') === f); });
    updateCta();
  }
  function updateCta() {
    if (!cta) return;
    var vid = sel.getAttribute('data-vid');
    var qtyN = sel.getAttribute('data-qty') || '1';
    var compare = parseInt(sel.getAttribute('data-compare'), 10) || 0;   // cents (pack MSRP)
    var price = parseInt(sel.getAttribute('data-price'), 10) || 0;        // cents (pack price)
    // Both modes add to the side cart. Subscription carries a "Plan" line property
    // so the cart's checkout button routes to WhatsApp; one-time -> Shopify checkout.
    // "_compare" carries the pack MSRP so the cart shows the discount (strikethrough + savings).
    cta.setAttribute('href', '/cart/' + vid + ':' + qtyN);
    cta.removeAttribute('target'); cta.removeAttribute('rel');
    cta.setAttribute('data-atc', ''); cta.setAttribute('data-variant', vid); cta.setAttribute('data-qty', qtyN);
    var props = {};
    if (freq === 'sub') {
      props._subpct = String(subPct);                              // cart applies the −30% in display + total
      props.Plan = 'Suscripción -' + subPct + '% mensual';
      cta.textContent = 'Suscribirme y ahorrar ' + subPct + '%';
    } else {
      if (compare > price) props._compare = String(compare);       // one-time: show pack MSRP strikethrough
      cta.textContent = 'Agregar al carrito \u00b7 ' + money(price);
    }
    if (Object.keys(props).length) cta.setAttribute('data-props', JSON.stringify(props));
    else cta.removeAttribute('data-props');
  }
  packs.forEach(function (p) { p.addEventListener('click', function () { setPack(p); }); });
  freqs.forEach(function (f) { f.addEventListener('click', function () { setFreq(f.getAttribute('data-freq')); }); });
  setPack(sel); setFreq(freq);
})();

/* ============================================================
   REVIEWS — write-a-review modal
   ============================================================ */
(function () {
  'use strict';
  var modal = document.querySelector('[data-rvf-modal]');
  if (!modal) return;
  function open() { modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function close() { modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  document.querySelectorAll('[data-rvf-open]').forEach(function (b) { b.addEventListener('click', open); });
  modal.querySelectorAll('[data-rvf-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) close(); });
})();

/* ============================================================
   REVIEWS — photo lightbox (RHO style)
   ============================================================ */
(function () {
  'use strict';
  var lb = document.querySelector('[data-rvf-lb]');
  var gallery = document.querySelector('[data-rvf-gallery]');
  if (!lb || !gallery) return;

  var btns = Array.prototype.slice.call(gallery.querySelectorAll('[data-rvf-photo]'));
  if (!btns.length) return;

  var photos = btns.map(function (b) {
    return {
      full: b.getAttribute('data-full'),
      thumb: b.querySelector('img') ? b.querySelector('img').getAttribute('src') : b.getAttribute('data-full'),
      name: b.getAttribute('data-name') || '',
      date: b.getAttribute('data-date') || '',
      title: b.getAttribute('data-title') || '',
      text: b.getAttribute('data-text') || ''
    };
  });

  var elImg = lb.querySelector('[data-rvf-lb-img]');
  var elThumbs = lb.querySelector('[data-rvf-lb-thumbs]');
  var elReview = lb.querySelector('[data-rvf-lb-review]');
  var elName = lb.querySelector('[data-rvf-lb-name]');
  var elVerif = lb.querySelector('[data-rvf-lb-verif]');
  var elDate = lb.querySelector('[data-rvf-lb-date]');
  var elTitle = lb.querySelector('[data-rvf-lb-title]');
  var elText = lb.querySelector('[data-rvf-lb-text]');
  var current = 0;

  // build thumbnail strip once
  photos.forEach(function (p, i) {
    var t = document.createElement('button');
    t.type = 'button';
    t.className = 'rvf__lb-thumb';
    t.innerHTML = '<img loading="lazy" decoding="async" src="' + p.thumb + '" alt="">';
    t.addEventListener('click', function () { show(i); });
    elThumbs.appendChild(t);
  });
  var thumbEls = Array.prototype.slice.call(elThumbs.children);

  function show(i) {
    current = (i + photos.length) % photos.length;
    var p = photos[current];
    elImg.src = p.full;
    thumbEls.forEach(function (t, j) { t.classList.toggle('is-active', j === current); });
    var active = thumbEls[current];
    if (active && active.scrollIntoView) active.scrollIntoView({ block: 'nearest', inline: 'center' });
    if (p.name || p.title || p.text) {
      elReview.hidden = false;
      elName.textContent = p.name;
      elVerif.style.display = p.name ? '' : 'none';
      elDate.textContent = p.date;
      elTitle.textContent = p.title;
      elTitle.style.display = p.title ? '' : 'none';
      elText.textContent = p.text;
    } else {
      elReview.hidden = true;
    }
  }
  function open(i) { show(i); lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function close() { lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

  btns.forEach(function (b, i) { b.addEventListener('click', function () { open(i); }); });
  lb.querySelectorAll('[data-rvf-lb-close]').forEach(function (b) { b.addEventListener('click', close); });
  lb.querySelector('[data-rvf-lb-prev]').addEventListener('click', function () { show(current - 1); });
  lb.querySelector('[data-rvf-lb-next]').addEventListener('click', function () { show(current + 1); });
  document.addEventListener('keydown', function (e) {
    if (!lb.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') show(current - 1);
    else if (e.key === 'ArrowRight') show(current + 1);
  });
  // swipe on the image
  var sx = 0;
  elImg.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
  elImg.addEventListener('touchend', function (e) {
    var dx = e.changedTouches[0].clientX - sx;
    if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
  }, { passive: true });
})();

/* ============================================================
   REVIEWS — pagination (1 · 2 · 3 ...)
   ============================================================ */
(function () {
  'use strict';
  var list = document.querySelector('[data-rvf-reviews]');
  var pager = document.querySelector('[data-rvf-pager]');
  if (!list || !pager) return;

  var revs = Array.prototype.slice.call(list.querySelectorAll('[data-rvf-rev]'));
  var per = parseInt(list.getAttribute('data-per'), 10) || 6;
  var pages = Math.ceil(revs.length / per);
  if (pages <= 1) return;

  var page = 1;

  function render() {
    revs.forEach(function (r, i) {
      var p = Math.floor(i / per) + 1;
      r.hidden = (p !== page);
    });
    pager.innerHTML = '';
    var prev = mkBtn('‹', 'rvf__pg rvf__pg--nav', function () { go(page - 1); });
    prev.disabled = page === 1;
    pager.appendChild(prev);

    // page numbers with simple windowing
    var win = [];
    for (var n = 1; n <= pages; n++) {
      if (n === 1 || n === pages || (n >= page - 1 && n <= page + 1)) win.push(n);
      else if (win[win.length - 1] !== '…') win.push('…');
    }
    win.forEach(function (n) {
      if (n === '…') {
        var s = document.createElement('span'); s.className = 'rvf__pg'; s.style.border = '0'; s.style.cursor = 'default'; s.textContent = '…';
        pager.appendChild(s);
      } else {
        var b = mkBtn(n, 'rvf__pg' + (n === page ? ' is-active' : ''), function () { go(n); });
        pager.appendChild(b);
      }
    });
    var next = mkBtn('›', 'rvf__pg rvf__pg--nav', function () { go(page + 1); });
    next.disabled = page === pages;
    pager.appendChild(next);
  }
  function mkBtn(label, cls, fn) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = cls; b.textContent = label;
    b.addEventListener('click', fn);
    return b;
  }
  function go(n) {
    if (n < 1 || n > pages || n === page) return;
    page = n;
    render();
    var top = list.getBoundingClientRect().top + window.pageYOffset - 80;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }
  render();
})();

/* ============================================================
   STICKY RITUAL CTA — barra inferior de 2 modos (08-sep-2026, Manuel)
   · packs FUERA de pantalla → "Elegir mi pack" y baja a los packs (destino VISIBLE:
     tira de premios > "Elige tu pack" > selector > #buy; antes apuntaba a #selector,
     que va oculto sin suscripción, y buscaba el id con "#" → no hacía nada)
   · packs EN pantalla → espejo del botón grande: mismo texto, mismo add al carrito
   ============================================================ */
(function () {
  'use strict';
  var bar = document.querySelector('[data-sticky-bar]');
  if (!bar) return;
  var btn = bar.querySelector('.sticky-bar__btn') || bar;
  var nombre = bar.querySelector('.sticky-bar__name');
  var nombreProd = nombre ? nombre.textContent : '';
  var labelIr = btn.textContent.replace(/\s+/g, ' ').trim();
  var flecha = btn.querySelector('svg') ? btn.querySelector('svg').outerHTML : '';
  function q(s) { return document.querySelector(s); }
  function visible(el) { return !!el && el.offsetParent !== null && el.getBoundingClientRect().height > 0; }
  function destino() {
    var id = (bar.getAttribute('data-target') || 'buy').replace(/^#/, '');
    var c = [q('.felic-bar'), q('#selector-packs'), q('[data-esc-packs-wrap]'), document.getElementById(id), document.getElementById('buy')];
    for (var i = 0; i < c.length; i++) if (visible(c[i])) return c[i];
    return null;
  }
  var packs = q('[data-esc-packs-wrap]');
  var cta = q('[data-esc-cta]');
  var packsEn = false, ctaEn = false;
  function modoCompra() { return (packsEn || ctaEn) && visible(cta); }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;'); }
  function pintar() {
    if (modoCompra()) {
      var txt = cta.textContent.replace(/\s+/g, ' ').trim().replace(/\s*·\s*S\/[\d.,]+\s*$/, '');   // el precio ya va a la izquierda
      btn.innerHTML = esc(txt || 'Agregar al carrito');
      bar.classList.add('is-buy');
      var act = q('[data-esc-pack].is-active .bp__pack-t');
      if (nombre) nombre.textContent = act ? act.textContent.replace(/\s+/g, ' ').trim() : nombreProd;
    } else {
      btn.innerHTML = esc(labelIr) + ' ' + flecha;
      bar.classList.remove('is-buy');
      if (nombre) nombre.textContent = nombreProd;
    }
  }
  bar.addEventListener('click', function (e) {
    e.preventDefault();
    if (modoCompra()) { cta.click(); return; }                       // mismo flujo que el botón grande (candado, premios, cajón)
    var d = destino(); if (!d) return;
    var y = d.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) - 84;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  });
  if ('IntersectionObserver' in window) {
    if (packs) new IntersectionObserver(function (es) { packsEn = es[0].isIntersecting; pintar(); }, { threshold: 0.1 }).observe(packs);
    if (cta) new IntersectionObserver(function (es) { ctaEn = es[0].isIntersecting; pintar(); }, { threshold: 0.5 }).observe(cta);
  }
  if (cta && 'MutationObserver' in window) new MutationObserver(function () { if (modoCompra()) pintar(); }).observe(cta, { childList: true, characterData: true, subtree: true });
  document.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('[data-esc-pack]')) setTimeout(pintar, 90); }, true);
  function update() { bar.classList.toggle('is-visible', (window.scrollY || window.pageYOffset) > 360); }
  window.addEventListener('scroll', update, { passive: true });
  update(); pintar();
})();

/* ============================================================
   BAR-UP — eleva FAB y toaster cuando hay sticky bar visible
   ============================================================ */
(function () {
  'use strict';
  var bars = document.querySelectorAll('.sticky-bar, .psticky');
  if (!bars.length) return;
  function sync() {
    var up = false;
    bars.forEach(function (b) { if (b.classList.contains('is-visible')) up = true; });
    document.body.classList.toggle('bar-up', up);
  }
  if ('MutationObserver' in window) {
    bars.forEach(function (b) {
      new MutationObserver(sync).observe(b, { attributes: true, attributeFilter: ['class'] });
    });
  }
  window.addEventListener('scroll', sync, { passive: true });
  sync();
})();

